export const reg_json = [
  {
    "id": "NAM",
    "name": "North America",
    "db": [
      {
        "id": "CA",
        "un": "CA",
        "name": "Canada",
        "int_id": 43,
        "db": [
          {
            "id": "CA-AB",
            "name": "Alberta",
            "int_id": 548
          },
          {
            "id": "CA-BC",
            "name": "British Columbia",
            "int_id": 545
          },
          {
            "id": "CA-MB",
            "name": "Manitoba",
            "int_id": 544
          },
          {
            "id": "CA-NB",
            "name": "New Brunswick",
            "int_id": 541
          },
          {
            "id": "CA-NL",
            "name": "Newfoundland and Labrador",
            "int_id": 549
          },
          {
            "id": "CA-NT",
            "name": "Northwest Territories",
            "int_id": 550
          },
          {
            "id": "CA-NS",
            "name": "Nova Scotia",
            "int_id": 542
          },
          {
            "id": "CA-NU",
            "name": "Nunavut",
            "int_id": 543
          },
          {
            "id": "CA-ON",
            "name": "Ontario",
            "int_id": 540
          },
          {
            "id": "CA-PE",
            "name": "Prince Edward Island",
            "int_id": 546
          },
          {
            "id": "CA-QC",
            "name": "Quebec",
            "int_id": 539
          },
          {
            "id": "CA-SK",
            "name": "Saskatchewan",
            "int_id": 547
          },
          {
            "id": "CA-YT",
            "name": "Yukon",
            "int_id": 551
          }
        ],
        "total": 13
      },
      {
        "id": "GL",
        "un": "DK",
        "name": "Greenland",
        "int_id": 90,
        "db": [
          {
            "id": "GL-E",
            "name": "East Greenland",
            "int_id": 1269
          },
          {
            "id": "GL-NW",
            "name": "Northwest Greenland",
            "int_id": 1268
          },
          {
            "id": "GL-SW",
            "name": "Southwest Greenland",
            "int_id": 1267
          }
        ],
        "total": 3
      },
      {
        "id": "PM",
        "un": "FR",
        "name": "Saint Pierre and Miquelon",
        "int_id": 195,
        "db": [
          {
            "id": "PM-M",
            "name": "Miquelon",
            "int_id": 1180
          },
          {
            "id": "PM-P",
            "name": "Saint-Pierre",
            "int_id": 1181
          }
        ],
        "total": 2
      },
      {
        "id": "US",
        "un": "US",
        "name": "United States of America",
        "int_id": 244,
        "db": [
          {
            "id": "US-AL",
            "name": "Alabama",
            "int_id": 507
          },
          {
            "id": "US-AK",
            "name": "Alaska",
            "int_id": 537
          },
          {
            "id": "US-AZ",
            "name": "Arizona",
            "int_id": 513
          },
          {
            "id": "US-AR",
            "name": "Arkansas",
            "int_id": 498
          },
          {
            "id": "US-CA",
            "name": "California",
            "int_id": 526
          },
          {
            "id": "US-CO",
            "name": "Colorado",
            "int_id": 509
          },
          {
            "id": "US-CT",
            "name": "Connecticut",
            "int_id": 530
          },
          {
            "id": "US-DE",
            "name": "Delaware",
            "int_id": 519
          },
          {
            "id": "US-DC",
            "name": "District of Columbia",
            "int_id": 517
          },
          {
            "id": "US-FL",
            "name": "Florida",
            "int_id": 514
          },
          {
            "id": "US-GA",
            "name": "Georgia",
            "int_id": 508
          },
          {
            "id": "US-ID",
            "name": "Idaho",
            "int_id": 522
          },
          {
            "id": "US-IL",
            "name": "Illinois",
            "int_id": 494
          },
          {
            "id": "US-IN",
            "name": "Indiana",
            "int_id": 504
          },
          {
            "id": "US-IA",
            "name": "Iowa",
            "int_id": 500
          },
          {
            "id": "US-KS",
            "name": "Kansas",
            "int_id": 496
          },
          {
            "id": "US-KY",
            "name": "Kentucky",
            "int_id": 503
          },
          {
            "id": "US-LA",
            "name": "Louisiana",
            "int_id": 534
          },
          {
            "id": "US-ME",
            "name": "Maine",
            "int_id": 491
          },
          {
            "id": "US-MD",
            "name": "Maryland",
            "int_id": 520
          },
          {
            "id": "US-MA",
            "name": "Massachusetts",
            "int_id": 489
          },
          {
            "id": "US-MI",
            "name": "Michigan",
            "int_id": 529
          },
          {
            "id": "US-MN",
            "name": "Minnesota",
            "int_id": 524
          },
          {
            "id": "US-MS",
            "name": "Mississippi",
            "int_id": 506
          },
          {
            "id": "US-MO",
            "name": "Missouri",
            "int_id": 495
          },
          {
            "id": "US-MT",
            "name": "Montana",
            "int_id": 521
          },
          {
            "id": "US-NE",
            "name": "Nebraska",
            "int_id": 499
          },
          {
            "id": "US-NV",
            "name": "Nevada",
            "int_id": 525
          },
          {
            "id": "US-NH",
            "name": "New Hampshire",
            "int_id": 492
          },
          {
            "id": "US-NJ",
            "name": "New Jersey",
            "int_id": 535
          },
          {
            "id": "US-NM",
            "name": "New Mexico",
            "int_id": 512
          },
          {
            "id": "US-NY",
            "name": "New York",
            "int_id": 490
          },
          {
            "id": "US-NC",
            "name": "North Carolina",
            "int_id": 533
          },
          {
            "id": "US-ND",
            "name": "North Dakota",
            "int_id": 502
          },
          {
            "id": "US-OH",
            "name": "Ohio",
            "int_id": 515
          },
          {
            "id": "US-OK",
            "name": "Oklahoma",
            "int_id": 497
          },
          {
            "id": "US-OR",
            "name": "Oregon",
            "int_id": 527
          },
          {
            "id": "US-PA",
            "name": "Pennsylvania",
            "int_id": 518
          },
          {
            "id": "US-RI",
            "name": "Rhode Island",
            "int_id": 536
          },
          {
            "id": "US-SC",
            "name": "South Carolina",
            "int_id": 531
          },
          {
            "id": "US-SD",
            "name": "South Dakota",
            "int_id": 501
          },
          {
            "id": "US-TN",
            "name": "Tennessee",
            "int_id": 505
          },
          {
            "id": "US-TX",
            "name": "Texas",
            "int_id": 493
          },
          {
            "id": "US-UT",
            "name": "Utah",
            "int_id": 511
          },
          {
            "id": "US-VT",
            "name": "Vermont",
            "int_id": 488
          },
          {
            "id": "US-VA",
            "name": "Virginia",
            "int_id": 532
          },
          {
            "id": "US-WA",
            "name": "Washington",
            "int_id": 528
          },
          {
            "id": "US-WV",
            "name": "West Virginia",
            "int_id": 516
          },
          {
            "id": "US-WI",
            "name": "Wisconsin",
            "int_id": 523
          },
          {
            "id": "US-WY",
            "name": "Wyoming",
            "int_id": 510
          }
        ],
        "total": 50
      }
    ],
    "total": 68
  },
  {
    "id": "CAM",
    "name": "Central America",
    "db": [
      {
        "id": "BZ",
        "un": "BZ",
        "name": "Belize",
        "int_id": 25,
        "db": [
          {
            "id": "BZ-C",
            "name": "Coastal",
            "int_id": 888
          },
          {
            "id": "BZ-I",
            "name": "Inland",
            "int_id": 889
          }
        ],
        "total": 2
      },
      {
        "id": "CR",
        "un": "CR",
        "name": "Costa Rica",
        "int_id": 56
      },
      {
        "id": "SV",
        "un": "SV",
        "name": "El Salvador",
        "int_id": 69
      },
      {
        "id": "GT",
        "un": "GT",
        "name": "Guatemala",
        "int_id": 94,
        "db": [
          {
            "id": "GT-18",
            "name": "Caribbean",
            "int_id": 740
          },
          {
            "id": "GT-H",
            "name": "Highlands",
            "int_id": 737
          },
          {
            "id": "GT-P",
            "name": "Pacific",
            "int_id": 738
          },
          {
            "id": "GT-17",
            "name": "Petén",
            "int_id": 739
          }
        ],
        "total": 4
      },
      {
        "id": "HN",
        "un": "HN",
        "name": "Honduras",
        "int_id": 102,
        "db": [
          {
            "id": "HN-IB",
            "name": "Bay Islands",
            "int_id": 1220
          },
          {
            "id": "HN-C",
            "name": "Caribbean",
            "int_id": 1219
          },
          {
            "id": "HN-H",
            "name": "Highlands",
            "int_id": 1222
          },
          {
            "id": "HN-P",
            "name": "Pacific",
            "int_id": 1221
          }
        ],
        "total": 4
      },
      {
        "id": "MX",
        "un": "MX",
        "name": "Mexico",
        "int_id": 147,
        "db": [
          {
            "id": "MX-AGU",
            "name": "Aguascalientes",
            "int_id": 955
          },
          {
            "id": "MX-BCN",
            "name": "Baja California",
            "int_id": 953
          },
          {
            "id": "MX-BCS",
            "name": "Baja California Sur",
            "int_id": 954
          },
          {
            "id": "MX-CAM",
            "name": "Campeche",
            "int_id": 952
          },
          {
            "id": "MX-CHP",
            "name": "Chiapas",
            "int_id": 950
          },
          {
            "id": "MX-CHH",
            "name": "Chihuahua",
            "int_id": 936
          },
          {
            "id": "MX-COA",
            "name": "Coahuila",
            "int_id": 935
          },
          {
            "id": "MX-COL",
            "name": "Colima",
            "int_id": 942
          },
          {
            "id": "MX-DUR",
            "name": "Durango",
            "int_id": 944
          },
          {
            "id": "MX-GUA",
            "name": "Guanajuato",
            "int_id": 940
          },
          {
            "id": "MX-GRO",
            "name": "Guerrero",
            "int_id": 947
          },
          {
            "id": "MX-HID",
            "name": "Hidalgo",
            "int_id": 932
          },
          {
            "id": "MX-JAL",
            "name": "Jalisco",
            "int_id": 941
          },
          {
            "id": "MX-CMX",
            "name": "Mexico City",
            "int_id": 929
          },
          {
            "id": "MX-MIC",
            "name": "Michoacán",
            "int_id": 938
          },
          {
            "id": "MX-MOR",
            "name": "Morelos",
            "int_id": 930
          },
          {
            "id": "MX-NAY",
            "name": "Nayarit",
            "int_id": 959
          },
          {
            "id": "MX-NLE",
            "name": "Nuevo León",
            "int_id": 934
          },
          {
            "id": "MX-OAX",
            "name": "Oaxaca",
            "int_id": 949
          },
          {
            "id": "MX-PUE",
            "name": "Puebla",
            "int_id": 933
          },
          {
            "id": "MX-QUE",
            "name": "Querétaro",
            "int_id": 939
          },
          {
            "id": "MX-ROO",
            "name": "Quintana Roo",
            "int_id": 956
          },
          {
            "id": "MX-SLP",
            "name": "San Luis Potosi",
            "int_id": 958
          },
          {
            "id": "MX-SIN",
            "name": "Sinaloa",
            "int_id": 948
          },
          {
            "id": "MX-SON",
            "name": "Sonora",
            "int_id": 937
          },
          {
            "id": "MX-MEX",
            "name": "State of Mexico",
            "int_id": 931
          },
          {
            "id": "MX-TAB",
            "name": "Tabasco",
            "int_id": 951
          },
          {
            "id": "MX-TAM",
            "name": "Tamaulipas",
            "int_id": 945
          },
          {
            "id": "MX-TLA",
            "name": "Tlaxcala",
            "int_id": 928
          },
          {
            "id": "MX-VER",
            "name": "Veracruz",
            "int_id": 946
          },
          {
            "id": "MX-YUC",
            "name": "Yucatán",
            "int_id": 957
          },
          {
            "id": "MX-ZAC",
            "name": "Zacatecas",
            "int_id": 943
          }
        ],
        "total": 32
      },
      {
        "id": "NI",
        "un": "NI",
        "name": "Nicaragua",
        "int_id": 163
      },
      {
        "id": "PA",
        "un": "PA",
        "name": "Panama",
        "int_id": 176
      }
    ],
    "total": 46
  },
  {
    "id": "CRB",
    "name": "Caribbean",
    "db": [
      {
        "id": "AI",
        "un": "GB",
        "name": "Anguilla",
        "int_id": 10
      },
      {
        "id": "AG",
        "un": "AG",
        "name": "Antigua and Barbuda",
        "int_id": 12,
        "db": [
          {
            "id": "AG:A",
            "name": "Antigua",
            "int_id": 1266
          },
          {
            "id": "AG-10",
            "name": "Barbuda",
            "int_id": 1265
          }
        ],
        "total": 2
      },
      {
        "id": "AW",
        "un": "NL",
        "name": "Aruba",
        "int_id": 15
      },
      {
        "id": "BS",
        "un": "BS",
        "name": "Bahamas",
        "int_id": 19
      },
      {
        "id": "BB",
        "un": "BB",
        "name": "Barbados",
        "int_id": 22
      },
      {
        "id": "BQ",
        "un": "NL",
        "name": "Bonaire, Sint Eustatius and Saba",
        "int_id": 30,
        "db": [
          {
            "id": "BQ-BO",
            "name": "Bonaire",
            "int_id": 1096
          },
          {
            "id": "BQ-SA",
            "name": "Saba",
            "int_id": 1097
          },
          {
            "id": "BQ-SE",
            "name": "Sint Eustatius",
            "int_id": 1098
          }
        ],
        "total": 3
      },
      {
        "id": "KY",
        "un": "GB",
        "name": "Cayman Islands",
        "int_id": 44
      },
      {
        "id": "CO",
        "un": "CO",
        "name": "Colombia",
        "int_id": 51,
        "db": [
          {
            "id": "CO-SAP",
            "name": "San Andrés, Providencia y Santa Catalina",
            "int_id": 870
          }
        ],
        "total": 1
      },
      {
        "id": "CU",
        "un": "CU",
        "name": "Cuba",
        "int_id": 59,
        "db": [
          {
            "id": "CU-C",
            "name": "Centre",
            "int_id": 1049
          },
          {
            "id": "CU-E",
            "name": "East",
            "int_id": 1050
          },
          {
            "id": "CU-99",
            "name": "Isla de la Juventud",
            "int_id": 1047
          },
          {
            "id": "CU-W",
            "name": "West",
            "int_id": 1048
          }
        ],
        "total": 4
      },
      {
        "id": "CW",
        "un": "NL",
        "name": "Curaçao",
        "int_id": 60
      },
      {
        "id": "DM",
        "un": "DM",
        "name": "Dominica",
        "int_id": 65
      },
      {
        "id": "DO",
        "un": "DO",
        "name": "Dominican Republic",
        "int_id": 66
      },
      {
        "id": "GD",
        "un": "GD",
        "name": "Grenada",
        "int_id": 91
      },
      {
        "id": "GP",
        "un": "FR",
        "name": "Guadeloupe",
        "int_id": 92
      },
      {
        "id": "HT",
        "un": "HT",
        "name": "Haiti",
        "int_id": 99
      },
      {
        "id": "JM",
        "un": "JM",
        "name": "Jamaica",
        "int_id": 114
      },
      {
        "id": "MQ",
        "un": "FR",
        "name": "Martinique",
        "int_id": 143
      },
      {
        "id": "MS",
        "un": "GB",
        "name": "Montserrat",
        "int_id": 153
      },
      {
        "id": "PR",
        "un": "US",
        "name": "Puerto Rico",
        "int_id": 184,
        "db": [
          {
            "id": "PR",
            "name": "Puerto Rico",
            "int_id": 184
          }
        ],
        "total": 1
      },
      {
        "id": "BL",
        "un": "FR",
        "name": "Saint Barthélemy",
        "int_id": 190
      },
      {
        "id": "KN",
        "un": "KN",
        "name": "Saint Kitts and Nevis",
        "int_id": 192,
        "db": [
          {
            "id": "KN-N",
            "name": "Nevis",
            "int_id": 1247
          },
          {
            "id": "KN-K",
            "name": "Saint Kitts",
            "int_id": 1246
          }
        ],
        "total": 2
      },
      {
        "id": "LC",
        "un": "LC",
        "name": "Saint Lucia",
        "int_id": 193
      },
      {
        "id": "MF",
        "un": "FR",
        "name": "Saint Martin",
        "int_id": 194
      },
      {
        "id": "VC",
        "un": "VC",
        "name": "Saint Vincent and the Grenadines",
        "int_id": 196,
        "db": [
          {
            "id": "VC-06",
            "name": "Grenadines",
            "int_id": 1238
          },
          {
            "id": "VC:0",
            "name": "Saint Vincent",
            "int_id": 1237
          }
        ],
        "total": 2
      },
      {
        "id": "SX",
        "un": "NL",
        "name": "Sint Maarten",
        "int_id": 206
      },
      {
        "id": "TT",
        "un": "TT",
        "name": "Trinidad and Tobago",
        "int_id": 233,
        "db": [
          {
            "id": "TT-TOB",
            "name": "Tobago",
            "int_id": 1245
          },
          {
            "id": "TT",
            "name": "Trinidad",
            "int_id": 233
          }
        ],
        "total": 2
      },
      {
        "id": "TC",
        "un": "GB",
        "name": "Turks and Caicos Islands",
        "int_id": 237
      },
      {
        "id": "VG",
        "un": "GB",
        "name": "Virgin Islands (British)",
        "int_id": 250
      },
      {
        "id": "VI",
        "un": "US",
        "name": "Virgin Islands (U.S.)",
        "int_id": 251,
        "db": [
          {
            "id": "VI",
            "name": "United States Virgin Islands",
            "int_id": 251
          }
        ],
        "total": 1
      }
    ],
    "total": 38
  },
  {
    "id": "SAM",
    "name": "South America",
    "db": [
      {
        "id": "AR",
        "un": "AR",
        "name": "Argentina",
        "int_id": 13,
        "db": [
          {
            "id": "AR-C",
            "name": "Autonomous City of Buenos Aires",
            "int_id": 696
          },
          {
            "id": "AR-B",
            "name": "Buenos Aires",
            "int_id": 693
          },
          {
            "id": "AR-K",
            "name": "Catamarca",
            "int_id": 681
          },
          {
            "id": "AR-H",
            "name": "Chaco",
            "int_id": 689
          },
          {
            "id": "AR-U",
            "name": "Chubut Province",
            "int_id": 683
          },
          {
            "id": "AR-X",
            "name": "Córdoba",
            "int_id": 697
          },
          {
            "id": "AR-W",
            "name": "Corrientes",
            "int_id": 687
          },
          {
            "id": "AR-E",
            "name": "Entre Ríos Province",
            "int_id": 686
          },
          {
            "id": "AR-P",
            "name": "Formosa",
            "int_id": 695
          },
          {
            "id": "AR-Y",
            "name": "Jujuy",
            "int_id": 690
          },
          {
            "id": "AR-L",
            "name": "La Pampa",
            "int_id": 678
          },
          {
            "id": "AR-F",
            "name": "La Rioja",
            "int_id": 674
          },
          {
            "id": "AR-M",
            "name": "Mendoza",
            "int_id": 677
          },
          {
            "id": "AR-N",
            "name": "Misiones",
            "int_id": 688
          },
          {
            "id": "AR-Q",
            "name": "Neuquén Province",
            "int_id": 692
          },
          {
            "id": "AR-R",
            "name": "Río Negro Province",
            "int_id": 682
          },
          {
            "id": "AR-A",
            "name": "Salta",
            "int_id": 694
          },
          {
            "id": "AR-J",
            "name": "San Juan",
            "int_id": 676
          },
          {
            "id": "AR-D",
            "name": "San Luis",
            "int_id": 675
          },
          {
            "id": "AR-Z",
            "name": "Santa Cruz Province",
            "int_id": 684
          },
          {
            "id": "AR-S",
            "name": "Santa Fe",
            "int_id": 679
          },
          {
            "id": "AR-G",
            "name": "Santiago del Estero",
            "int_id": 680
          },
          {
            "id": "AR-V",
            "name": "Tierra del Fuego Province",
            "int_id": 685
          },
          {
            "id": "AR-T",
            "name": "Tucumán",
            "int_id": 691
          }
        ],
        "total": 24
      },
      {
        "id": "BO",
        "un": "BO",
        "name": "Bolivia",
        "int_id": 29,
        "db": [
          {
            "id": "BO-1",
            "name": "Altiplano",
            "int_id": 863
          },
          {
            "id": "BO-2",
            "name": "Sub-Andean Bolivia",
            "int_id": 862
          },
          {
            "id": "BO-3",
            "name": "Tropical Lowlands",
            "int_id": 864
          }
        ],
        "total": 3
      },
      {
        "id": "BR",
        "un": "BR",
        "name": "Brazil",
        "int_id": 34,
        "db": [
          {
            "id": "BR-AC",
            "name": "Acre",
            "int_id": 462
          },
          {
            "id": "BR-AL",
            "name": "Alagoas",
            "int_id": 458
          },
          {
            "id": "BR-AP",
            "name": "Amapá",
            "int_id": 464
          },
          {
            "id": "BR-AM",
            "name": "Amazonas",
            "int_id": 465
          },
          {
            "id": "BR-BA",
            "name": "Bahia",
            "int_id": 471
          },
          {
            "id": "BR-CE",
            "name": "Ceará",
            "int_id": 455
          },
          {
            "id": "BR-ES",
            "name": "Espírito Santo",
            "int_id": 446
          },
          {
            "id": "BR-DF",
            "name": "Federal District",
            "int_id": 472
          },
          {
            "id": "BR-GO",
            "name": "Goiás",
            "int_id": 469
          },
          {
            "id": "BR-MA",
            "name": "Maranhão",
            "int_id": 466
          },
          {
            "id": "BR-MT",
            "name": "Mato Grosso",
            "int_id": 467
          },
          {
            "id": "BR-MS",
            "name": "Mato Grosso do Sul",
            "int_id": 468
          },
          {
            "id": "BR-MG",
            "name": "Minas Gerais",
            "int_id": 460
          },
          {
            "id": "BR-PA",
            "name": "Pará",
            "int_id": 448
          },
          {
            "id": "BR-PB",
            "name": "Paraíba",
            "int_id": 454
          },
          {
            "id": "BR-PR",
            "name": "Paraná",
            "int_id": 451
          },
          {
            "id": "BR-PE",
            "name": "Pernambuco",
            "int_id": 457
          },
          {
            "id": "BR-PI",
            "name": "Piauí",
            "int_id": 456
          },
          {
            "id": "BR-RJ",
            "name": "Rio de Janeiro",
            "int_id": 447
          },
          {
            "id": "BR-RN",
            "name": "Rio Grande do Norte",
            "int_id": 453
          },
          {
            "id": "BR-RS",
            "name": "Rio Grande do Sul",
            "int_id": 449
          },
          {
            "id": "BR-RO",
            "name": "Rondônia",
            "int_id": 461
          },
          {
            "id": "BR-RR",
            "name": "Roraima",
            "int_id": 463
          },
          {
            "id": "BR-SC",
            "name": "Santa Catarina",
            "int_id": 450
          },
          {
            "id": "BR-SP",
            "name": "São Paulo",
            "int_id": 452
          },
          {
            "id": "BR-SE",
            "name": "Sergipe",
            "int_id": 459
          },
          {
            "id": "BR-TO",
            "name": "Tocantins",
            "int_id": 470
          }
        ],
        "total": 27
      },
      {
        "id": "CL",
        "un": "CL",
        "name": "Chile",
        "int_id": 47,
        "db": [
          {
            "id": "CL-VS:2",
            "name": "Archipielago Juan Fernandez",
            "int_id": 735
          },
          {
            "id": "CL:C",
            "name": "Central Chile",
            "int_id": 731
          },
          {
            "id": "CL:N",
            "name": "Northern Chile",
            "int_id": 732
          },
          {
            "id": "CL:P",
            "name": "Patagonia",
            "int_id": 734
          },
          {
            "id": "CL:S",
            "name": "Southern Chile",
            "int_id": 733
          }
        ],
        "total": 5
      },
      {
        "id": "CO",
        "un": "CO",
        "name": "Colombia",
        "int_id": 51,
        "db": [
          {
            "id": "CO-AM",
            "name": "Amazonia",
            "int_id": 866
          },
          {
            "id": "CO-AN",
            "name": "Andino",
            "int_id": 865
          },
          {
            "id": "CO-C",
            "name": "Costa Norte",
            "int_id": 868
          },
          {
            "id": "CO-O",
            "name": "Orinoquía",
            "int_id": 867
          },
          {
            "id": "CO-P",
            "name": "Pacifica",
            "int_id": 869
          }
        ],
        "total": 5
      },
      {
        "id": "EC",
        "un": "EC",
        "name": "Ecuador",
        "int_id": 67,
        "db": [
          {
            "id": "EC3",
            "name": "Amazon",
            "int_id": 634
          },
          {
            "id": "EC1",
            "name": "Coast",
            "int_id": 635
          },
          {
            "id": "EC-W",
            "name": "Galápagos",
            "int_id": 636
          },
          {
            "id": "EC2",
            "name": "Sierra",
            "int_id": 633
          }
        ],
        "total": 4
      },
      {
        "id": "GF",
        "un": "FR",
        "name": "French Guiana",
        "int_id": 80
      },
      {
        "id": "GY",
        "un": "GY",
        "name": "Guyana",
        "int_id": 98
      },
      {
        "id": "PY",
        "un": "PY",
        "name": "Paraguay",
        "int_id": 178,
        "db": [
          {
            "id": "PY-GC",
            "name": "Gran Chaco",
            "int_id": 858
          },
          {
            "id": "PY-NP",
            "name": "Northern Paraneña",
            "int_id": 859
          },
          {
            "id": "PY-PP",
            "name": "Paraná Plateau",
            "int_id": 860
          },
          {
            "id": "PY-SP",
            "name": "Southern Paraneña",
            "int_id": 861
          }
        ],
        "total": 4
      },
      {
        "id": "PE",
        "un": "PE",
        "name": "Peru",
        "int_id": 179,
        "db": [
          {
            "id": "PE-PUN",
            "name": "Altiplano",
            "int_id": 1054
          },
          {
            "id": "PE-CC",
            "name": "Central Coast",
            "int_id": 1057
          },
          {
            "id": "PE-CS",
            "name": "Central Sierra",
            "int_id": 1058
          },
          {
            "id": "PE-MDD",
            "name": "Madre de Dios",
            "int_id": 1052
          },
          {
            "id": "PE-NC",
            "name": "Northern Coast",
            "int_id": 1059
          },
          {
            "id": "PE-NS",
            "name": "Northern Sierra",
            "int_id": 1053
          },
          {
            "id": "PE-PA",
            "name": "Peruvian Amazon",
            "int_id": 1055
          },
          {
            "id": "PE-SC",
            "name": "Southern Coast",
            "int_id": 1051
          },
          {
            "id": "PE-SS",
            "name": "Southern Sierra",
            "int_id": 1056
          }
        ],
        "total": 9
      },
      {
        "id": "SR",
        "un": "SR",
        "name": "Suriname",
        "int_id": 219
      },
      {
        "id": "UY",
        "un": "UY",
        "name": "Uruguay",
        "int_id": 245
      },
      {
        "id": "VE",
        "un": "VE",
        "name": "Venezuela",
        "int_id": 248,
        "db": [
          {
            "id": "VE-AN",
            "name": "Andes",
            "int_id": 780
          },
          {
            "id": "VE-CI",
            "name": "Caribbean Islands",
            "int_id": 786
          },
          {
            "id": "VE-CR",
            "name": "Central Region",
            "int_id": 783
          },
          {
            "id": "VE-CO",
            "name": "Coro region",
            "int_id": 784
          },
          {
            "id": "VE-GU",
            "name": "Guayana",
            "int_id": 785
          },
          {
            "id": "VE-LL",
            "name": "Los Llanos",
            "int_id": 781
          },
          {
            "id": "VE-DO",
            "name": "Orinoco Delta",
            "int_id": 782
          },
          {
            "id": "VE-V",
            "name": "Zulia",
            "int_id": 779
          }
        ],
        "total": 8
      }
    ],
    "total": 93
  },
  {
    "id": "ATL",
    "name": "Atlantic Ocean",
    "db": [
      {
        "id": "BM",
        "un": "GB",
        "name": "Bermuda",
        "int_id": 27
      },
      {
        "id": "BV",
        "un": "NO",
        "name": "Bouvet Island",
        "int_id": 33
      },
      {
        "id": "BR",
        "un": "BR",
        "name": "Brazil",
        "int_id": 34,
        "db": [
          {
            "id": "BR-PE:1",
            "name": "Fernando de Noronha",
            "int_id": 473
          }
        ],
        "total": 1
      },
      {
        "id": "FK",
        "un": "GB",
        "name": "Falkland Islands (Malvinas)",
        "int_id": 75
      },
      {
        "id": "PT",
        "un": "PT",
        "name": "Portugal",
        "int_id": 183,
        "db": [
          {
            "id": "PT-20",
            "name": "Azores",
            "int_id": 910
          },
          {
            "id": "PT-30",
            "name": "Madeira",
            "int_id": 909
          }
        ],
        "total": 2
      },
      {
        "id": "SH",
        "un": "GB",
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "int_id": 191,
        "db": [
          {
            "id": "SH-AC",
            "name": "Ascension",
            "int_id": 707
          },
          {
            "id": "SH-HL",
            "name": "Saint Helena",
            "int_id": 706
          },
          {
            "id": "SH-TA",
            "name": "Tristan da Cunha",
            "int_id": 708
          }
        ],
        "total": 3
      },
      {
        "id": "GS",
        "un": "GB",
        "name": "South Georgia and the South Sandwich Islands",
        "int_id": 213
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "int_id": 216,
        "db": [
          {
            "id": "ES-CN",
            "name": "Canary Islands",
            "int_id": 833
          }
        ],
        "total": 1
      }
    ],
    "total": 11
  },
  {
    "id": "EUW",
    "name": "Western Europe",
    "db": [
      {
        "id": "AT",
        "un": "AT",
        "name": "Austria",
        "int_id": 17,
        "db": [
          {
            "id": "AT-1",
            "name": "Burgenland",
            "int_id": 321
          },
          {
            "id": "AT-2",
            "name": "Carinthia",
            "int_id": 319
          },
          {
            "id": "AT-3",
            "name": "Lower Austria",
            "int_id": 322
          },
          {
            "id": "AT-5",
            "name": "Salzburg",
            "int_id": 323
          },
          {
            "id": "AT-6",
            "name": "Styria",
            "int_id": 317
          },
          {
            "id": "AT-7",
            "name": "Tyrol",
            "int_id": 318
          },
          {
            "id": "AT-4",
            "name": "Upper Austria",
            "int_id": 324
          },
          {
            "id": "AT-9",
            "name": "Vienna",
            "int_id": 325
          },
          {
            "id": "AT-8",
            "name": "Vorarlberg",
            "int_id": 320
          }
        ],
        "total": 9
      },
      {
        "id": "BE",
        "un": "BE",
        "name": "Belgium",
        "int_id": 24,
        "db": [
          {
            "id": "BE-BRU",
            "name": "Brussels-Capital",
            "int_id": 444
          },
          {
            "id": "BE-VLG",
            "name": "Flanders",
            "int_id": 443
          },
          {
            "id": "BE-WAL",
            "name": "Wallonia",
            "int_id": 445
          }
        ],
        "total": 3
      },
      {
        "id": "FR",
        "un": "FR",
        "name": "France",
        "int_id": 79,
        "db": [
          {
            "id": "FR-A",
            "name": "Alsace",
            "int_id": 271
          },
          {
            "id": "FR-B",
            "name": "Aquitaine",
            "int_id": 258
          },
          {
            "id": "FR-C",
            "name": "Auvergne",
            "int_id": 262
          },
          {
            "id": "FR-E",
            "name": "Brittany",
            "int_id": 269
          },
          {
            "id": "FR-D",
            "name": "Burgundy",
            "int_id": 267
          },
          {
            "id": "FR-F",
            "name": "Centre-Val de Loire",
            "int_id": 257
          },
          {
            "id": "FR-G",
            "name": "Champagne-Ardenne",
            "int_id": 260
          },
          {
            "id": "FR-H",
            "name": "Corsica",
            "int_id": 278
          },
          {
            "id": "FR-I",
            "name": "Franche-Comté",
            "int_id": 273
          },
          {
            "id": "FR-J",
            "name": "Île-de-France",
            "int_id": 264
          },
          {
            "id": "FR-K",
            "name": "Languedoc-Roussillon",
            "int_id": 276
          },
          {
            "id": "FR-L",
            "name": "Limousin",
            "int_id": 275
          },
          {
            "id": "FR-M",
            "name": "Lorraine",
            "int_id": 263
          },
          {
            "id": "FR-P",
            "name": "Lower Normandy",
            "int_id": 272
          },
          {
            "id": "FR-N",
            "name": "Midi-Pyrénées",
            "int_id": 266
          },
          {
            "id": "FR-O",
            "name": "Nord-Pas-de-Calais",
            "int_id": 268
          },
          {
            "id": "FR-R",
            "name": "Pays de la Loire",
            "int_id": 270
          },
          {
            "id": "FR-S",
            "name": "Picardy",
            "int_id": 274
          },
          {
            "id": "FR-T",
            "name": "Poitou-Charentes",
            "int_id": 259
          },
          {
            "id": "FR-U",
            "name": "Provence-Alpes-Côte d'Azur",
            "int_id": 261
          },
          {
            "id": "FR-V",
            "name": "Rhône-Alpes",
            "int_id": 265
          },
          {
            "id": "FR-Q",
            "name": "Upper Normandy",
            "int_id": 277
          }
        ],
        "total": 22
      },
      {
        "id": "DE",
        "un": "DE",
        "name": "Germany",
        "int_id": 86,
        "db": [
          {
            "id": "DE-BW",
            "name": "Baden-Württemberg",
            "int_id": 310
          },
          {
            "id": "DE-BY",
            "name": "Bavaria",
            "int_id": 316
          },
          {
            "id": "DE-BE",
            "name": "Berlin",
            "int_id": 306
          },
          {
            "id": "DE-BB",
            "name": "Brandenburg",
            "int_id": 308
          },
          {
            "id": "DE-HB",
            "name": "Bremen",
            "int_id": 312
          },
          {
            "id": "DE-HH",
            "name": "Hamburg",
            "int_id": 315
          },
          {
            "id": "DE-HE",
            "name": "Hesse",
            "int_id": 311
          },
          {
            "id": "DE-NI",
            "name": "Lower Saxony",
            "int_id": 314
          },
          {
            "id": "DE-MV",
            "name": "Mecklenburg-Vorpommern",
            "int_id": 301
          },
          {
            "id": "DE-NW",
            "name": "North Rhine-Westphalia",
            "int_id": 313
          },
          {
            "id": "DE-RP",
            "name": "Rhineland-Palatinate",
            "int_id": 303
          },
          {
            "id": "DE-SL",
            "name": "Saarland",
            "int_id": 305
          },
          {
            "id": "DE-SN",
            "name": "Saxony",
            "int_id": 307
          },
          {
            "id": "DE-ST",
            "name": "Saxony-Anhalt",
            "int_id": 309
          },
          {
            "id": "DE-SH",
            "name": "Schleswig-Holstein",
            "int_id": 302
          },
          {
            "id": "DE-TH",
            "name": "Thuringia",
            "int_id": 304
          }
        ],
        "total": 16
      },
      {
        "id": "LI",
        "un": "LI",
        "name": "Liechtenstein",
        "int_id": 132
      },
      {
        "id": "LU",
        "un": "LU",
        "name": "Luxembourg",
        "int_id": 134
      },
      {
        "id": "MC",
        "un": "MC",
        "name": "Monaco",
        "int_id": 150
      },
      {
        "id": "NL",
        "un": "NL",
        "name": "Netherlands",
        "int_id": 160,
        "db": [
          {
            "id": "NL2",
            "name": "East",
            "int_id": 352
          },
          {
            "id": "NL1",
            "name": "North",
            "int_id": 351
          },
          {
            "id": "NL4",
            "name": "South",
            "int_id": 354
          },
          {
            "id": "NL3",
            "name": "West",
            "int_id": 353
          }
        ],
        "total": 4
      },
      {
        "id": "CH",
        "un": "CH",
        "name": "Switzerland",
        "int_id": 222,
        "db": [
          {
            "id": "CH-AG",
            "name": "Aargau",
            "int_id": 1002
          },
          {
            "id": "CH-AR",
            "name": "Appenzell Ausserrhoden",
            "int_id": 1008
          },
          {
            "id": "CH-AI",
            "name": "Appenzell Innerrhoden",
            "int_id": 1009
          },
          {
            "id": "CH-BS",
            "name": "Basel-City",
            "int_id": 1020
          },
          {
            "id": "CH-BL",
            "name": "Basel-Landschaft",
            "int_id": 1003
          },
          {
            "id": "CH-BE",
            "name": "Bern",
            "int_id": 1001
          },
          {
            "id": "CH-FR",
            "name": "Fribourg",
            "int_id": 1019
          },
          {
            "id": "CH-GE",
            "name": "Geneva",
            "int_id": 1022
          },
          {
            "id": "CH-GL",
            "name": "Glarus",
            "int_id": 999
          },
          {
            "id": "CH-GR",
            "name": "Grisons",
            "int_id": 1007
          },
          {
            "id": "CH-JU",
            "name": "Jura",
            "int_id": 1018
          },
          {
            "id": "CH-LU",
            "name": "Lucerne",
            "int_id": 1000
          },
          {
            "id": "CH-NE",
            "name": "Neuchâtel",
            "int_id": 1023
          },
          {
            "id": "CH-NW",
            "name": "Nidwalden",
            "int_id": 1006
          },
          {
            "id": "CH-OW",
            "name": "Obwalden",
            "int_id": 1005
          },
          {
            "id": "CH-SH",
            "name": "Schaffhausen",
            "int_id": 1017
          },
          {
            "id": "CH-SZ",
            "name": "Schwyz",
            "int_id": 1013
          },
          {
            "id": "CH-SO",
            "name": "Solothurn",
            "int_id": 1021
          },
          {
            "id": "CH-SG",
            "name": "St. Gallen",
            "int_id": 1011
          },
          {
            "id": "CH-TG",
            "name": "Thurgau",
            "int_id": 1015
          },
          {
            "id": "CH-TI",
            "name": "Ticino",
            "int_id": 1012
          },
          {
            "id": "CH-UR",
            "name": "Uri",
            "int_id": 1016
          },
          {
            "id": "CH-VD",
            "name": "Vaud",
            "int_id": 1024
          },
          {
            "id": "CH-VS",
            "name": "Wallis",
            "int_id": 1010
          },
          {
            "id": "CH-ZG",
            "name": "Zug",
            "int_id": 1004
          },
          {
            "id": "CH-ZH",
            "name": "Zurich",
            "int_id": 1014
          }
        ],
        "total": 26
      }
    ],
    "total": 83
  },
  {
    "id": "EUN",
    "name": "Northern Europe",
    "db": [
      {
        "id": "AX",
        "un": "FI",
        "name": "Åland Islands",
        "int_id": 4,
        "db": [
          {
            "id": "AX",
            "name": "Åland Islands",
            "int_id": 4
          }
        ],
        "total": 1
      },
      {
        "id": "DK",
        "un": "DK",
        "name": "Denmark",
        "int_id": 63,
        "db": [
          {
            "id": "DK-040",
            "name": "Bornholm",
            "int_id": 925
          },
          {
            "id": "DK-84",
            "name": "Capital Region",
            "int_id": 924
          },
          {
            "id": "DK-82",
            "name": "Central Denmark",
            "int_id": 920
          },
          {
            "id": "DK-81",
            "name": "North Denmark",
            "int_id": 921
          },
          {
            "id": "DK-83",
            "name": "Southern Denmark",
            "int_id": 922
          },
          {
            "id": "DK-85",
            "name": "Zealand",
            "int_id": 923
          }
        ],
        "total": 6
      },
      {
        "id": "EE",
        "un": "EE",
        "name": "Estonia",
        "int_id": 72
      },
      {
        "id": "FO",
        "un": "DK",
        "name": "Faroe Islands",
        "int_id": 76
      },
      {
        "id": "FI",
        "un": "FI",
        "name": "Finland",
        "int_id": 78,
        "db": [
          {
            "id": "FI-L",
            "name": "Lakeland",
            "int_id": 328
          },
          {
            "id": "FI-N",
            "name": "Northern Finland",
            "int_id": 329
          },
          {
            "id": "FI-S",
            "name": "Southern Finland",
            "int_id": 326
          },
          {
            "id": "FI-W",
            "name": "West Coast",
            "int_id": 327
          }
        ],
        "total": 4
      },
      {
        "id": "GG",
        "un": "GB",
        "name": "Guernsey",
        "int_id": 95
      },
      {
        "id": "IS",
        "un": "IS",
        "name": "Iceland",
        "int_id": 105,
        "db": [
          {
            "id": "IS-E",
            "name": "Eurasian plate",
            "int_id": 1235
          },
          {
            "id": "IS-A",
            "name": "North American plate",
            "int_id": 1236
          },
          {
            "id": "IS-R",
            "name": "Reykjavík and Reykjanesbær",
            "int_id": 1234
          }
        ],
        "total": 3
      },
      {
        "id": "IE",
        "un": "IE",
        "name": "Ireland",
        "int_id": 110,
        "db": [
          {
            "id": "IE-C",
            "name": "Connacht",
            "int_id": 787
          },
          {
            "id": "IE-L",
            "name": "Leinster",
            "int_id": 788
          },
          {
            "id": "IE-M",
            "name": "Munster",
            "int_id": 789
          },
          {
            "id": "IE-U",
            "name": "Ulster",
            "int_id": 790
          }
        ],
        "total": 4
      },
      {
        "id": "IM",
        "un": "GB",
        "name": "Isle of Man",
        "int_id": 111
      },
      {
        "id": "JE",
        "un": "GB",
        "name": "Jersey",
        "int_id": 116
      },
      {
        "id": "LV",
        "un": "LV",
        "name": "Latvia",
        "int_id": 127
      },
      {
        "id": "LT",
        "un": "LT",
        "name": "Lithuania",
        "int_id": 133
      },
      {
        "id": "NO",
        "un": "NO",
        "name": "Norway",
        "int_id": 171,
        "db": [
          {
            "id": "NO-42",
            "name": "Agder",
            "int_id": 875
          },
          {
            "id": "NO-E",
            "name": "Eastern Norway",
            "int_id": 872
          },
          {
            "id": "NO-N",
            "name": "Northern Norway",
            "int_id": 874
          },
          {
            "id": "NO-50",
            "name": "Trøndelag",
            "int_id": 873
          },
          {
            "id": "NO-W",
            "name": "Western Norway",
            "int_id": 871
          }
        ],
        "total": 5
      },
      {
        "id": "SJ",
        "un": "NO",
        "name": "Svalbard and Jan Mayen",
        "int_id": 220,
        "db": [
          {
            "id": "SJ-2",
            "name": "Jan Mayen",
            "int_id": 926
          },
          {
            "id": "NO-21",
            "name": "Svalbard",
            "int_id": 927
          }
        ],
        "total": 2
      },
      {
        "id": "SE",
        "un": "SE",
        "name": "Sweden",
        "int_id": 221,
        "db": [
          {
            "id": "SE3",
            "name": "Götaland",
            "int_id": 441
          },
          {
            "id": "SE-I",
            "name": "Gotland",
            "int_id": 442
          },
          {
            "id": "SE1",
            "name": "Norrland",
            "int_id": 439
          },
          {
            "id": "SE2",
            "name": "Svealand",
            "int_id": 440
          }
        ],
        "total": 4
      },
      {
        "id": "GB",
        "un": "GB",
        "name": "United Kingdom",
        "int_id": 242,
        "db": [
          {
            "id": "GB-1EM",
            "name": "England - East Midlands",
            "int_id": 282
          },
          {
            "id": "GB-1EE",
            "name": "England - East of",
            "int_id": 280
          },
          {
            "id": "GB-IOS",
            "name": "England - Isles of Scilly",
            "int_id": 290
          },
          {
            "id": "GB-1L",
            "name": "England - London",
            "int_id": 281
          },
          {
            "id": "GB-1NE",
            "name": "England - North East",
            "int_id": 287
          },
          {
            "id": "GB-1NW",
            "name": "England - North West",
            "int_id": 288
          },
          {
            "id": "GB-1SE",
            "name": "England - South East",
            "int_id": 285
          },
          {
            "id": "GB-1SW",
            "name": "England - South West",
            "int_id": 283
          },
          {
            "id": "GB-1WM",
            "name": "England - West Midlands",
            "int_id": 279
          },
          {
            "id": "GB-1YH",
            "name": "England - Yorkshire and the Humber",
            "int_id": 286
          },
          {
            "id": "GB-NIR",
            "name": "Northern Ireland",
            "int_id": 289
          },
          {
            "id": "GB-2H",
            "name": "Scotland - Highlands",
            "int_id": 293
          },
          {
            "id": "GB-2L",
            "name": "Scotland - Lowlands",
            "int_id": 294
          },
          {
            "id": "GB-ORK",
            "name": "Scotland - Orkney Islands",
            "int_id": 292
          },
          {
            "id": "GB-ELS",
            "name": "Scotland - Outer Hebrides",
            "int_id": 295
          },
          {
            "id": "GB-ZET",
            "name": "Scotland - Shetland Islands",
            "int_id": 296
          },
          {
            "id": "GB-3W",
            "name": "Wales",
            "int_id": 284
          },
          {
            "id": "GB-AGY",
            "name": "Wales - Isle of Anglesey",
            "int_id": 291
          }
        ],
        "total": 18
      }
    ],
    "total": 54
  },
  {
    "id": "EUS",
    "name": "Southern Europe",
    "db": [
      {
        "id": "AL",
        "un": "AL",
        "name": "Albania",
        "int_id": 5
      },
      {
        "id": "AD",
        "un": "AD",
        "name": "Andorra",
        "int_id": 8
      },
      {
        "id": "BA",
        "un": "BA",
        "name": "Bosnia and Herzegovina",
        "int_id": 31,
        "db": [
          {
            "id": "BA-BRC",
            "name": "Brčko District",
            "int_id": 1102
          },
          {
            "id": "BA-BIH",
            "name": "Federation of Bosnia and Herzegovina",
            "int_id": 1103
          },
          {
            "id": "BA-SRP",
            "name": "Republika Srpska",
            "int_id": 1104
          }
        ],
        "total": 3
      },
      {
        "id": "HR",
        "un": "HR",
        "name": "Croatia",
        "int_id": 58,
        "db": [
          {
            "id": "HR-D",
            "name": "Dalmacija",
            "int_id": 751
          },
          {
            "id": "HR-18",
            "name": "Istria",
            "int_id": 749
          },
          {
            "id": "HR-K",
            "name": "Kvarner",
            "int_id": 750
          },
          {
            "id": "HR-S",
            "name": "Slavonija",
            "int_id": 747
          },
          {
            "id": "HR-C",
            "name": "Središnja Hrvatska",
            "int_id": 748
          }
        ],
        "total": 5
      },
      {
        "id": "GI",
        "un": "GB",
        "name": "Gibraltar",
        "int_id": 88
      },
      {
        "id": "GR",
        "un": "GR",
        "name": "Greece",
        "int_id": 89,
        "db": [
          {
            "id": "GR:CNT",
            "name": "Central Greece",
            "int_id": 793
          },
          {
            "id": "GR-M",
            "name": "Crete",
            "int_id": 791
          },
          {
            "id": "GR-F",
            "name": "Ioanian Islands",
            "int_id": 795
          },
          {
            "id": "GR-69",
            "name": "Mount Athos",
            "int_id": 798
          },
          {
            "id": "GR-K",
            "name": "Northern Aegean",
            "int_id": 796
          },
          {
            "id": "GR:NOR",
            "name": "Northern Greece",
            "int_id": 792
          },
          {
            "id": "GR:PEL",
            "name": "Peloponnese",
            "int_id": 794
          },
          {
            "id": "GR-L",
            "name": "South Aegean",
            "int_id": 797
          }
        ],
        "total": 8
      },
      {
        "id": "VA",
        "un": "ZZ",
        "name": "Holy See",
        "int_id": 101
      },
      {
        "id": "IT",
        "un": "IT",
        "name": "Italy",
        "int_id": 113,
        "db": [
          {
            "id": "IT-65",
            "name": "Abruzzo",
            "int_id": 346
          },
          {
            "id": "IT-23",
            "name": "Aosta Valley",
            "int_id": 343
          },
          {
            "id": "IT-75",
            "name": "Apulia",
            "int_id": 332
          },
          {
            "id": "IT-77",
            "name": "Basilicata",
            "int_id": 333
          },
          {
            "id": "IT-78",
            "name": "Calabria",
            "int_id": 349
          },
          {
            "id": "IT-72",
            "name": "Campania",
            "int_id": 334
          },
          {
            "id": "IT-45",
            "name": "Emilia-Romagna",
            "int_id": 339
          },
          {
            "id": "IT-36",
            "name": "Friuli-Venezia Giulia",
            "int_id": 347
          },
          {
            "id": "IT-62",
            "name": "Lazio",
            "int_id": 335
          },
          {
            "id": "IT-42",
            "name": "Liguria",
            "int_id": 348
          },
          {
            "id": "IT-25",
            "name": "Lombardy",
            "int_id": 342
          },
          {
            "id": "IT-57",
            "name": "Marche",
            "int_id": 345
          },
          {
            "id": "IT-67",
            "name": "Molise",
            "int_id": 336
          },
          {
            "id": "IT:PP",
            "name": "Pantelleria, Lampedusa e Linosa",
            "int_id": 330
          },
          {
            "id": "IT-21",
            "name": "Piedmont",
            "int_id": 341
          },
          {
            "id": "IT-88",
            "name": "Sardinia",
            "int_id": 350
          },
          {
            "id": "IT-82",
            "name": "Sicily",
            "int_id": 331
          },
          {
            "id": "IT-32",
            "name": "Trentino-Alto Adige/Südtirol",
            "int_id": 344
          },
          {
            "id": "IT-52",
            "name": "Tuscany",
            "int_id": 337
          },
          {
            "id": "IT-55",
            "name": "Umbria",
            "int_id": 338
          },
          {
            "id": "IT-34",
            "name": "Veneto",
            "int_id": 340
          }
        ],
        "total": 21
      },
      {
        "id": "XK",
        "un": "RS",
        "name": "Kosovo",
        "int_id": 123
      },
      {
        "id": "MT",
        "un": "MT",
        "name": "Malta",
        "int_id": 141,
        "db": [
          {
            "id": "MT:G",
            "name": "Gozo",
            "int_id": 848
          },
          {
            "id": "MT:M",
            "name": "Malta",
            "int_id": 847
          }
        ],
        "total": 2
      },
      {
        "id": "ME",
        "un": "ME",
        "name": "Montenegro",
        "int_id": 152,
        "db": [
          {
            "id": "ME:C",
            "name": "Central",
            "int_id": 1073
          },
          {
            "id": "ME:M",
            "name": "North Montenegrin Mountains",
            "int_id": 1072
          },
          {
            "id": "ME:R",
            "name": "Riviera",
            "int_id": 1071
          }
        ],
        "total": 3
      },
      {
        "id": "MK",
        "un": "MK",
        "name": "North Macedonia",
        "int_id": 168
      },
      {
        "id": "PT",
        "un": "PT",
        "name": "Portugal",
        "int_id": 183,
        "db": [
          {
            "id": "PT:A",
            "name": "Alentejo Region",
            "int_id": 908
          },
          {
            "id": "PT-08",
            "name": "Algarve",
            "int_id": 904
          },
          {
            "id": "PT:C",
            "name": "Central Portugal",
            "int_id": 907
          },
          {
            "id": "PT-11",
            "name": "Lisbon",
            "int_id": 905
          },
          {
            "id": "PT:N",
            "name": "Northern Portugal",
            "int_id": 906
          }
        ],
        "total": 5
      },
      {
        "id": "SM",
        "un": "SM",
        "name": "San Marino",
        "int_id": 198
      },
      {
        "id": "RS",
        "un": "RS",
        "name": "Serbia",
        "int_id": 202,
        "db": [
          {
            "id": "RS-00",
            "name": "City of Belgrade",
            "int_id": 912
          },
          {
            "id": "RS:W",
            "name": "Podrinje",
            "int_id": 914
          },
          {
            "id": "RS:P",
            "name": "Podunavlje",
            "int_id": 913
          },
          {
            "id": "RS:S",
            "name": "Šumadija",
            "int_id": 915
          },
          {
            "id": "RS-VO",
            "name": "Vojvodina",
            "int_id": 911
          }
        ],
        "total": 5
      },
      {
        "id": "SI",
        "un": "SI",
        "name": "Slovenia",
        "int_id": 208
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "int_id": 216,
        "db": [
          {
            "id": "ES-AN",
            "name": "Andalusia",
            "int_id": 826
          },
          {
            "id": "ES-AR",
            "name": "Aragon",
            "int_id": 827
          },
          {
            "id": "ES-AS",
            "name": "Asturias",
            "int_id": 821
          },
          {
            "id": "ES-IB",
            "name": "Balearic Islands",
            "int_id": 817
          },
          {
            "id": "ES-PV",
            "name": "Basque Country",
            "int_id": 824
          },
          {
            "id": "ES-CB",
            "name": "Cantabria",
            "int_id": 819
          },
          {
            "id": "ES-CL",
            "name": "Castile and León",
            "int_id": 823
          },
          {
            "id": "ES-CM",
            "name": "Castile-La Mancha",
            "int_id": 830
          },
          {
            "id": "ES-CT",
            "name": "Catalonia",
            "int_id": 831
          },
          {
            "id": "ES-MD",
            "name": "Community of Madrid",
            "int_id": 832
          },
          {
            "id": "ES-EX",
            "name": "Extremadura",
            "int_id": 829
          },
          {
            "id": "ES-GA",
            "name": "Galicia",
            "int_id": 822
          },
          {
            "id": "ES-NC",
            "name": "Navarre",
            "int_id": 820
          },
          {
            "id": "ES-MC",
            "name": "Region of Murcia",
            "int_id": 828
          },
          {
            "id": "ES-RI",
            "name": "Rioja",
            "int_id": 818
          },
          {
            "id": "ES-VC",
            "name": "Valencian Community",
            "int_id": 825
          }
        ],
        "total": 16
      }
    ],
    "total": 76
  },
  {
    "id": "EUE",
    "name": "Eastern Europe",
    "db": [
      {
        "id": "BY",
        "un": "BY",
        "name": "Belarus",
        "int_id": 23,
        "db": [
          {
            "id": "BY-E",
            "name": "Eastern",
            "int_id": 485
          },
          {
            "id": "BY-HM",
            "name": "Minsk",
            "int_id": 487
          },
          {
            "id": "BY-W",
            "name": "Western",
            "int_id": 486
          }
        ],
        "total": 3
      },
      {
        "id": "BG",
        "un": "BG",
        "name": "Bulgaria",
        "int_id": 37,
        "db": [
          {
            "id": "BG3",
            "name": "Black Sea",
            "int_id": 917
          },
          {
            "id": "BG1",
            "name": "Danubian Plain",
            "int_id": 918
          },
          {
            "id": "BG0",
            "name": "Shopluk",
            "int_id": 919
          },
          {
            "id": "BG2",
            "name": "Thracian Valley",
            "int_id": 916
          }
        ],
        "total": 4
      },
      {
        "id": "CZ",
        "un": "CZ",
        "name": "Czechia",
        "int_id": 62,
        "db": [
          {
            "id": "CZ1",
            "name": "Bohemia",
            "int_id": 882
          },
          {
            "id": "CZ-63",
            "name": "Kraj Vysočina",
            "int_id": 884
          },
          {
            "id": "CZ2",
            "name": "Moravia",
            "int_id": 883
          },
          {
            "id": "CZ-80",
            "name": "Moravskoslezský kraj",
            "int_id": 885
          }
        ],
        "total": 4
      },
      {
        "id": "HU",
        "un": "HU",
        "name": "Hungary",
        "int_id": 104,
        "db": [
          {
            "id": "HU1",
            "name": "Central Hungary",
            "int_id": 298
          },
          {
            "id": "HU4",
            "name": "Great Plain",
            "int_id": 299
          },
          {
            "id": "HU3",
            "name": "Northern Hungary",
            "int_id": 300
          },
          {
            "id": "HU2",
            "name": "Transdanubia",
            "int_id": 297
          }
        ],
        "total": 4
      },
      {
        "id": "MD",
        "un": "MD",
        "name": "Moldova",
        "int_id": 149,
        "db": [
          {
            "id": "MD-GA",
            "name": "Gagauzia",
            "int_id": 484
          },
          {
            "id": "MD1",
            "name": "Moldova",
            "int_id": 483
          }
        ],
        "total": 2
      },
      {
        "id": "PL",
        "un": "PL",
        "name": "Poland",
        "int_id": 182,
        "db": [
          {
            "id": "PL-GPL",
            "name": "Greater Poland",
            "int_id": 629
          },
          {
            "id": "PL-LPL",
            "name": "Lesser Poland",
            "int_id": 627
          },
          {
            "id": "PL-MAS",
            "name": "Masovia",
            "int_id": 628
          },
          {
            "id": "PL-20",
            "name": "Podlasie",
            "int_id": 632
          },
          {
            "id": "PL-POM",
            "name": "Pomerania",
            "int_id": 626
          },
          {
            "id": "PL-SIL",
            "name": "Silesia",
            "int_id": 631
          },
          {
            "id": "PL-28",
            "name": "Warmia-Masuria",
            "int_id": 630
          }
        ],
        "total": 7
      },
      {
        "id": "RO",
        "un": "RO",
        "name": "Romania",
        "int_id": 187,
        "db": [
          {
            "id": "RO4",
            "name": "Banat",
            "int_id": 481
          },
          {
            "id": "RO-SV",
            "name": "Bucovina",
            "int_id": 478
          },
          {
            "id": "RO5",
            "name": "Crișana",
            "int_id": 476
          },
          {
            "id": "RO1",
            "name": "Dobrogea",
            "int_id": 482
          },
          {
            "id": "RO6",
            "name": "Maramureș",
            "int_id": 475
          },
          {
            "id": "RO7",
            "name": "Moldova",
            "int_id": 479
          },
          {
            "id": "RO2",
            "name": "Muntenia",
            "int_id": 477
          },
          {
            "id": "RO3",
            "name": "Oltenia",
            "int_id": 480
          },
          {
            "id": "RO8",
            "name": "Transylvania",
            "int_id": 474
          }
        ],
        "total": 9
      },
      {
        "id": "RU",
        "un": "RU",
        "name": "Russian Federation",
        "int_id": 188,
        "db": [
          {
            "id": "RU-ARK",
            "name": "Arkhangelsk Oblast",
            "int_id": 402
          },
          {
            "id": "RU-AST",
            "name": "Astrakhan Oblast",
            "int_id": 395
          },
          {
            "id": "RU-BA",
            "name": "Bashkortostan",
            "int_id": 372
          },
          {
            "id": "RU-BEL",
            "name": "Belgorod Oblast",
            "int_id": 380
          },
          {
            "id": "RU-BRY",
            "name": "Bryansk Oblast",
            "int_id": 379
          },
          {
            "id": "RU-CE",
            "name": "Chechnya",
            "int_id": 391
          },
          {
            "id": "RU-CU",
            "name": "Chuvashia",
            "int_id": 374
          },
          {
            "id": "RU:CR",
            "name": "Crimea",
            "int_id": 369
          },
          {
            "id": "RU-DA",
            "name": "Dagestan",
            "int_id": 390
          },
          {
            "id": "RU-IN",
            "name": "Ingushetia",
            "int_id": 405
          },
          {
            "id": "RU-IVA",
            "name": "Ivanovo Oblast",
            "int_id": 382
          },
          {
            "id": "RU-KB",
            "name": "Kabardino-Balkaria",
            "int_id": 393
          },
          {
            "id": "RU-KGD",
            "name": "Kaliningrad",
            "int_id": 386
          },
          {
            "id": "RU-KLU",
            "name": "Kaluga Oblast",
            "int_id": 377
          },
          {
            "id": "RU-KC",
            "name": "Karachay-Cherkessia",
            "int_id": 392
          },
          {
            "id": "RU-KIR",
            "name": "Kirov Oblast",
            "int_id": 396
          },
          {
            "id": "RU-KO",
            "name": "Komi Republic",
            "int_id": 401
          },
          {
            "id": "RU-KOS",
            "name": "Kostroma Oblast",
            "int_id": 383
          },
          {
            "id": "RU-KDA",
            "name": "Krasnodar Krai",
            "int_id": 388
          },
          {
            "id": "RU-KRS",
            "name": "Kursk Oblast",
            "int_id": 367
          },
          {
            "id": "RU-LEN",
            "name": "Leningrad oblast",
            "int_id": 404
          },
          {
            "id": "RU-LIP",
            "name": "Lipetsk Oblast",
            "int_id": 357
          },
          {
            "id": "RU-ME",
            "name": "Mari El Republic",
            "int_id": 398
          },
          {
            "id": "RU-MOW",
            "name": "Moscow",
            "int_id": 385
          },
          {
            "id": "RU-MOS",
            "name": "Moscow Oblast",
            "int_id": 355
          },
          {
            "id": "RU-MUR",
            "name": "Murmansk Oblast",
            "int_id": 411
          },
          {
            "id": "RU-NEN",
            "name": "Nenets Autonomous Okrug",
            "int_id": 407
          },
          {
            "id": "RU-NIZ",
            "name": "Nizhny Novgorod Oblast",
            "int_id": 364
          },
          {
            "id": "RU-NGR",
            "name": "Novgorod Oblast",
            "int_id": 384
          },
          {
            "id": "RU-ORE",
            "name": "Orenburg Oblast",
            "int_id": 371
          },
          {
            "id": "RU-ORL",
            "name": "Oryol Oblast",
            "int_id": 368
          },
          {
            "id": "RU-PNZ",
            "name": "Penza Oblast",
            "int_id": 360
          },
          {
            "id": "RU-PER",
            "name": "Perm Krai",
            "int_id": 400
          },
          {
            "id": "RU-PSK",
            "name": "Pskov Oblast",
            "int_id": 403
          },
          {
            "id": "RU-AD",
            "name": "Republic of Adygea",
            "int_id": 406
          },
          {
            "id": "RU-KL",
            "name": "Republic of Kalmykia",
            "int_id": 389
          },
          {
            "id": "RU-KR",
            "name": "Republic of Karelia",
            "int_id": 409
          },
          {
            "id": "RU-MO",
            "name": "Republic of Mordovia",
            "int_id": 365
          },
          {
            "id": "RU-SE",
            "name": "Republic of North Ossetia – Alania",
            "int_id": 394
          },
          {
            "id": "RU-ROS",
            "name": "Rostov Oblast",
            "int_id": 381
          },
          {
            "id": "RU-RYA",
            "name": "Ryazan Oblast",
            "int_id": 356
          },
          {
            "id": "RU-SPE",
            "name": "Saint Petersburg",
            "int_id": 408
          },
          {
            "id": "RU-SAM",
            "name": "Samara Oblast",
            "int_id": 363
          },
          {
            "id": "RU-SAR",
            "name": "Saratov Oblast",
            "int_id": 362
          },
          {
            "id": "RU-SMO",
            "name": "Smolensk Oblast",
            "int_id": 378
          },
          {
            "id": "RU-STA",
            "name": "Stavropol Krai",
            "int_id": 387
          },
          {
            "id": "RU-TAM",
            "name": "Tambov Oblast",
            "int_id": 358
          },
          {
            "id": "RU-TA",
            "name": "Tatarstan",
            "int_id": 373
          },
          {
            "id": "RU-TUL",
            "name": "Tula Oblast",
            "int_id": 375
          },
          {
            "id": "RU-TVE",
            "name": "Tver Oblast",
            "int_id": 410
          },
          {
            "id": "RU-UD",
            "name": "Udmurtia",
            "int_id": 399
          },
          {
            "id": "RU-ULY",
            "name": "Ulyanovsk Oblast",
            "int_id": 361
          },
          {
            "id": "RU-VLA",
            "name": "Vladimir Oblast",
            "int_id": 366
          },
          {
            "id": "RU-VGG",
            "name": "Volgograd Oblast",
            "int_id": 370
          },
          {
            "id": "RU-VLG",
            "name": "Vologda Oblast",
            "int_id": 397
          },
          {
            "id": "RU-VOR",
            "name": "Voronezh Oblast",
            "int_id": 359
          },
          {
            "id": "RU-YAR",
            "name": "Yaroslavl Oblast",
            "int_id": 376
          }
        ],
        "total": 57
      },
      {
        "id": "SK",
        "un": "SK",
        "name": "Slovakia",
        "int_id": 207,
        "db": [
          {
            "id": "SK2",
            "name": "Central Slovakia",
            "int_id": 856
          },
          {
            "id": "SK3",
            "name": "Eastern Slovakia",
            "int_id": 857
          },
          {
            "id": "SK1",
            "name": "Western Slovakia",
            "int_id": 855
          }
        ],
        "total": 3
      },
      {
        "id": "XT",
        "un": "MD",
        "name": "Transnistria",
        "int_id": 232,
        "db": [
          {
            "id": "XT",
            "name": "Transnistria",
            "int_id": 232
          }
        ],
        "total": 1
      },
      {
        "id": "UA",
        "un": "UA",
        "name": "Ukraine",
        "int_id": 240,
        "db": [
          {
            "id": "UA-71",
            "name": "Cherkasy Oblast",
            "int_id": 572
          },
          {
            "id": "UA-74",
            "name": "Chernihiv Oblast",
            "int_id": 557
          },
          {
            "id": "UA-77",
            "name": "Chernivtsi Oblast",
            "int_id": 567
          },
          {
            "id": "UA-12",
            "name": "Dnipropetrovsk Oblast",
            "int_id": 574
          },
          {
            "id": "UA-14",
            "name": "Donetsk Oblast",
            "int_id": 561
          },
          {
            "id": "UA-26",
            "name": "Ivano-Frankivsk Oblast",
            "int_id": 564
          },
          {
            "id": "UA-63",
            "name": "Kharkiv Oblast",
            "int_id": 559
          },
          {
            "id": "UA-65",
            "name": "Kherson Oblast",
            "int_id": 552
          },
          {
            "id": "UA-68",
            "name": "Khmelnytskyi Oblast",
            "int_id": 571
          },
          {
            "id": "UA-35",
            "name": "Kirovohrad Oblast",
            "int_id": 575
          },
          {
            "id": "UA-K",
            "name": "Kyiv and Kyiv Oblast",
            "int_id": 556
          },
          {
            "id": "UA-09",
            "name": "Luhansk Oblast",
            "int_id": 560
          },
          {
            "id": "UA-46",
            "name": "Lviv Oblast",
            "int_id": 563
          },
          {
            "id": "UA-48",
            "name": "Mykolaiv Oblast",
            "int_id": 569
          },
          {
            "id": "UA-51",
            "name": "Odesa Oblast",
            "int_id": 568
          },
          {
            "id": "UA-53",
            "name": "Poltava Oblast",
            "int_id": 573
          },
          {
            "id": "UA-56",
            "name": "Rivne Oblast",
            "int_id": 554
          },
          {
            "id": "UA-59",
            "name": "Sumy Oblast",
            "int_id": 558
          },
          {
            "id": "UA-61",
            "name": "Ternopil Oblast",
            "int_id": 566
          },
          {
            "id": "UA-05",
            "name": "Vinnytsia Oblast",
            "int_id": 570
          },
          {
            "id": "UA-07",
            "name": "Volyn Oblast",
            "int_id": 553
          },
          {
            "id": "UA-21",
            "name": "Zakarpattia Oblast",
            "int_id": 565
          },
          {
            "id": "UA-23",
            "name": "Zaporizhia Oblast",
            "int_id": 562
          },
          {
            "id": "UA-18",
            "name": "Zhytomyr Oblast",
            "int_id": 555
          }
        ],
        "total": 24
      }
    ],
    "total": 118
  },
  {
    "id": "AFN",
    "name": "Northern Africa",
    "db": [
      {
        "id": "DZ",
        "un": "DZ",
        "name": "Algeria",
        "int_id": 6,
        "db": [
          {
            "id": "DZ-C",
            "name": "Central Algeria",
            "int_id": 709
          },
          {
            "id": "DZ-NE",
            "name": "Northeast Algeria",
            "int_id": 713
          },
          {
            "id": "DZ-NW",
            "name": "Northwest Algeria",
            "int_id": 712
          },
          {
            "id": "DZ-S",
            "name": "Saharan Algeria",
            "int_id": 711
          },
          {
            "id": "DZ-A",
            "name": "Saharan Atlas",
            "int_id": 710
          }
        ],
        "total": 5
      },
      {
        "id": "EG",
        "un": "EG",
        "name": "Egypt",
        "int_id": 68,
        "db": [
          {
            "id": "EG.LE",
            "name": "Lower Egypt",
            "int_id": 1137
          },
          {
            "id": "EG-MT",
            "name": "Matruh",
            "int_id": 1135
          },
          {
            "id": "EG.ME",
            "name": "Middle Egypt",
            "int_id": 1138
          },
          {
            "id": "EG-BA",
            "name": "Red Sea",
            "int_id": 1134
          },
          {
            "id": "EG.SI",
            "name": "Sinai",
            "int_id": 1132
          },
          {
            "id": "EG.UE",
            "name": "Upper Egypt",
            "int_id": 1133
          },
          {
            "id": "EG-WAD",
            "name": "Western Desert",
            "int_id": 1136
          }
        ],
        "total": 7
      },
      {
        "id": "LY",
        "un": "LY",
        "name": "Libya",
        "int_id": 131,
        "db": [
          {
            "id": "LY-C",
            "name": "Cyrenaica",
            "int_id": 1066
          },
          {
            "id": "LY-S",
            "name": "Saharan Libya",
            "int_id": 1067
          },
          {
            "id": "LY-T",
            "name": "Tripolitania",
            "int_id": 1068
          }
        ],
        "total": 3
      },
      {
        "id": "MA",
        "un": "MA",
        "name": "Morocco",
        "int_id": 154,
        "db": [
          {
            "id": "MA:AA",
            "name": "Anti Atlas",
            "int_id": 967
          },
          {
            "id": "MA-03",
            "name": "Fez-Meknes",
            "int_id": 970
          },
          {
            "id": "MA:HA",
            "name": "High Atlas",
            "int_id": 966
          },
          {
            "id": "MA:MM",
            "name": "Mediterranean Coast",
            "int_id": 963
          },
          {
            "id": "MA:NA",
            "name": "North Atlantic Coast",
            "int_id": 968
          },
          {
            "id": "MA:SM",
            "name": "Saharan Morocco",
            "int_id": 964
          },
          {
            "id": "MA:SA",
            "name": "South Atlantic Coast",
            "int_id": 965
          },
          {
            "id": "MA:WS",
            "name": "Western Sahara",
            "int_id": 969
          }
        ],
        "total": 8
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "int_id": 216,
        "db": [
          {
            "id": "ES-CE",
            "name": "Ceuta",
            "int_id": 834
          },
          {
            "id": "ES-ML",
            "name": "Melilla",
            "int_id": 835
          }
        ],
        "total": 2
      },
      {
        "id": "SD",
        "un": "SD",
        "name": "Sudan",
        "int_id": 218,
        "db": [
          {
            "id": "SD-C",
            "name": "Central Sudan",
            "int_id": 1214
          },
          {
            "id": "SD-D",
            "name": "Darfur",
            "int_id": 1210
          },
          {
            "id": "SD-E",
            "name": "Eastern Sudan",
            "int_id": 1212
          },
          {
            "id": "SD-K",
            "name": "Kurdufan",
            "int_id": 1211
          },
          {
            "id": "SD-N",
            "name": "Northern Sudan",
            "int_id": 1213
          }
        ],
        "total": 5
      },
      {
        "id": "TN",
        "un": "TN",
        "name": "Tunisia",
        "int_id": 234,
        "db": [
          {
            "id": "TN2",
            "name": "Central Coastal Tunisia",
            "int_id": 961
          },
          {
            "id": "TN1",
            "name": "Northern Tunisia",
            "int_id": 962
          },
          {
            "id": "TN3",
            "name": "Saharan Tunisia",
            "int_id": 960
          }
        ],
        "total": 3
      },
      {
        "id": "EH",
        "un": "ZZ",
        "name": "Western Sahara",
        "int_id": 253
      }
    ],
    "total": 34
  },
  {
    "id": "AFW",
    "name": "Western Africa",
    "db": [
      {
        "id": "BJ",
        "un": "BJ",
        "name": "Benin",
        "int_id": 26
      },
      {
        "id": "BF",
        "un": "BF",
        "name": "Burkina Faso",
        "int_id": 38,
        "db": [
          {
            "id": "BF-BV",
            "name": "Black Volta",
            "int_id": 892
          },
          {
            "id": "BF-E",
            "name": "East",
            "int_id": 890
          },
          {
            "id": "BF-N",
            "name": "Sahelian Burkina Faso",
            "int_id": 891
          },
          {
            "id": "BF-VD",
            "name": "Volta Delta",
            "int_id": 893
          }
        ],
        "total": 4
      },
      {
        "id": "CV",
        "un": "CV",
        "name": "Cabo Verde",
        "int_id": 40,
        "db": [
          {
            "id": "CV-B",
            "name": "Barlavento Islands",
            "int_id": 1231
          },
          {
            "id": "CV-S",
            "name": "Sotavento Islands",
            "int_id": 1232
          }
        ],
        "total": 2
      },
      {
        "id": "CI",
        "un": "CI",
        "name": "Côte d'Ivoire",
        "int_id": 57,
        "db": [
          {
            "id": "CI:EP",
            "name": "Eastern Plantations",
            "int_id": 971
          },
          {
            "id": "CI:LG",
            "name": "Lagunes",
            "int_id": 973
          },
          {
            "id": "CI:NS",
            "name": "Northern Savanna",
            "int_id": 972
          },
          {
            "id": "CI:SF",
            "name": "Southwestern Forests",
            "int_id": 974
          }
        ],
        "total": 4
      },
      {
        "id": "GM",
        "un": "GM",
        "name": "Gambia",
        "int_id": 84
      },
      {
        "id": "GH",
        "un": "GH",
        "name": "Ghana",
        "int_id": 87,
        "db": [
          {
            "id": "GH:A",
            "name": "Ashanti-Kwahu",
            "int_id": 1062
          },
          {
            "id": "GH:C",
            "name": "Coastal Plain",
            "int_id": 1060
          },
          {
            "id": "GH:N",
            "name": "Northern Plains",
            "int_id": 1061
          },
          {
            "id": "GH:V",
            "name": "Volta Basin",
            "int_id": 1063
          }
        ],
        "total": 4
      },
      {
        "id": "GN",
        "un": "GN",
        "name": "Guinea",
        "int_id": 96,
        "db": [
          {
            "id": "GN:GF",
            "name": "Guinée Forestière",
            "int_id": 1165
          },
          {
            "id": "GN:MR",
            "name": "Guinée Maritime",
            "int_id": 1164
          },
          {
            "id": "GN:HG",
            "name": "Haute-Guinée",
            "int_id": 1166
          },
          {
            "id": "GN:MG",
            "name": "Moyenne-Guinée",
            "int_id": 1163
          }
        ],
        "total": 4
      },
      {
        "id": "GW",
        "un": "GW",
        "name": "Guinea-Bissau",
        "int_id": 97,
        "db": [
          {
            "id": "GW:B",
            "name": "Arquipélago dos Bijagós",
            "int_id": 725
          },
          {
            "id": "GW:0",
            "name": "Guinea-Bissau proper",
            "int_id": 724
          }
        ],
        "total": 2
      },
      {
        "id": "LR",
        "un": "LR",
        "name": "Liberia",
        "int_id": 130
      },
      {
        "id": "ML",
        "un": "ML",
        "name": "Mali",
        "int_id": 140,
        "db": [
          {
            "id": "ML-N",
            "name": "Northern Mali",
            "int_id": 1069
          },
          {
            "id": "ML-S",
            "name": "Southern Mali",
            "int_id": 1070
          }
        ],
        "total": 2
      },
      {
        "id": "MR",
        "un": "MR",
        "name": "Mauritania",
        "int_id": 144,
        "db": [
          {
            "id": "MR-1",
            "name": "Coastal Mauritania",
            "int_id": 1178
          },
          {
            "id": "MR-3",
            "name": "Saharan Mauritania",
            "int_id": 1177
          },
          {
            "id": "MR-2",
            "name": "Sahelian Mauritania",
            "int_id": 1179
          }
        ],
        "total": 3
      },
      {
        "id": "NE",
        "un": "NE",
        "name": "Niger",
        "int_id": 164,
        "db": [
          {
            "id": "NE-1",
            "name": "Agadez",
            "int_id": 1145
          },
          {
            "id": "NE-S",
            "name": "Sahelian Niger",
            "int_id": 1146
          },
          {
            "id": "NE-W",
            "name": "Southwestern Niger",
            "int_id": 1147
          }
        ],
        "total": 3
      },
      {
        "id": "NG",
        "un": "NG",
        "name": "Nigeria",
        "int_id": 165,
        "db": [
          {
            "id": "NG-SSZ",
            "name": "Niger Delta region",
            "int_id": 1190
          },
          {
            "id": "NG-NCZ",
            "name": "North Central Nigeria",
            "int_id": 1191
          },
          {
            "id": "NG-NEZ",
            "name": "North East Nigeria",
            "int_id": 1187
          },
          {
            "id": "NG-NWZ",
            "name": "North West Nigeria",
            "int_id": 1188
          },
          {
            "id": "NG-SEZ",
            "name": "South East Nigeria",
            "int_id": 1189
          },
          {
            "id": "NG-SWZ",
            "name": "South West Nigeria",
            "int_id": 1192
          }
        ],
        "total": 6
      },
      {
        "id": "SN",
        "un": "SN",
        "name": "Senegal",
        "int_id": 201
      },
      {
        "id": "SL",
        "un": "SL",
        "name": "Sierra Leone",
        "int_id": 204,
        "db": [
          {
            "id": "SL2",
            "name": "North and East",
            "int_id": 1154
          },
          {
            "id": "SL1",
            "name": "West and South",
            "int_id": 1155
          }
        ],
        "total": 2
      },
      {
        "id": "TG",
        "un": "TG",
        "name": "Togo",
        "int_id": 229
      }
    ],
    "total": 41
  },
  {
    "id": "AFE",
    "name": "Eastern Africa",
    "db": [
      {
        "id": "BI",
        "un": "BI",
        "name": "Burundi",
        "int_id": 39
      },
      {
        "id": "KM",
        "un": "KM",
        "name": "Comoros",
        "int_id": 52
      },
      {
        "id": "DJ",
        "un": "DJ",
        "name": "Djibouti",
        "int_id": 64
      },
      {
        "id": "ER",
        "un": "ER",
        "name": "Eritrea",
        "int_id": 71
      },
      {
        "id": "ET",
        "un": "ET",
        "name": "Ethiopia",
        "int_id": 74,
        "db": [
          {
            "id": "ET-AA",
            "name": "Addis Ababa",
            "int_id": 1034
          },
          {
            "id": "ET-AF",
            "name": "Afar Region",
            "int_id": 1026
          },
          {
            "id": "ET-AM",
            "name": "Amhara Region",
            "int_id": 1027
          },
          {
            "id": "ET-BE",
            "name": "Benishangul-Gumuz Region",
            "int_id": 1028
          },
          {
            "id": "ET-GA",
            "name": "Gambela Region",
            "int_id": 1030
          },
          {
            "id": "ET:1",
            "name": "Harar and Dire Dawa",
            "int_id": 1029
          },
          {
            "id": "ET-OR",
            "name": "Oromia Region",
            "int_id": 1031
          },
          {
            "id": "ET-SI",
            "name": "Sidama",
            "int_id": 1035
          },
          {
            "id": "ET-SO",
            "name": "Somali Region",
            "int_id": 1033
          },
          {
            "id": "ET-SW",
            "name": "South West Ethiopia Peoples",
            "int_id": 1036
          },
          {
            "id": "ET-SN",
            "name": "Southern Nations, Nationalities, and Peoples",
            "int_id": 1032
          },
          {
            "id": "ET-TI",
            "name": "Tigray",
            "int_id": 1025
          }
        ],
        "total": 12
      },
      {
        "id": "KE",
        "un": "KE",
        "name": "Kenya",
        "int_id": 119,
        "db": [
          {
            "id": "KE-200",
            "name": "Central",
            "int_id": 1172
          },
          {
            "id": "KE-300",
            "name": "Coast",
            "int_id": 1173
          },
          {
            "id": "KE-400",
            "name": "Eastern",
            "int_id": 1169
          },
          {
            "id": "KE-30",
            "name": "Nairobi County",
            "int_id": 1170
          },
          {
            "id": "KE-500",
            "name": "North-Eastern",
            "int_id": 1171
          },
          {
            "id": "KE-700",
            "name": "Rift Valley",
            "int_id": 1168
          },
          {
            "id": "KE-W",
            "name": "Western Kenya",
            "int_id": 1167
          }
        ],
        "total": 7
      },
      {
        "id": "MG",
        "un": "MG",
        "name": "Madagascar",
        "int_id": 136,
        "db": [
          {
            "id": "MG-T",
            "name": "Antananarivo",
            "int_id": 1143
          },
          {
            "id": "MG-D",
            "name": "Antsiranana",
            "int_id": 1144
          },
          {
            "id": "MG-F",
            "name": "Fianarantsoa",
            "int_id": 1140
          },
          {
            "id": "MG-M",
            "name": "Mahajanga",
            "int_id": 1141
          },
          {
            "id": "MG-A",
            "name": "Toamasina",
            "int_id": 1142
          },
          {
            "id": "MG-U",
            "name": "Toliara",
            "int_id": 1139
          }
        ],
        "total": 6
      },
      {
        "id": "MW",
        "un": "MW",
        "name": "Malawi",
        "int_id": 137,
        "db": [
          {
            "id": "MW-C",
            "name": "Central",
            "int_id": 1174
          },
          {
            "id": "MW-N",
            "name": "Northern",
            "int_id": 1176
          },
          {
            "id": "MW-S",
            "name": "Southern",
            "int_id": 1175
          }
        ],
        "total": 3
      },
      {
        "id": "MZ",
        "un": "MZ",
        "name": "Mozambique",
        "int_id": 155,
        "db": [
          {
            "id": "MZ2",
            "name": "Central Mozambique",
            "int_id": 1121
          },
          {
            "id": "MZ3",
            "name": "Northern Mozambique",
            "int_id": 1119
          },
          {
            "id": "MZ1",
            "name": "Southern Mozambique",
            "int_id": 1120
          }
        ],
        "total": 3
      },
      {
        "id": "RW",
        "un": "RW",
        "name": "Rwanda",
        "int_id": 189
      },
      {
        "id": "SO",
        "un": "SO",
        "name": "Somalia",
        "int_id": 210,
        "db": [
          {
            "id": "SO-P",
            "name": "Puntland",
            "int_id": 1038
          },
          {
            "id": "SO1",
            "name": "Southern Somalia",
            "int_id": 1037
          }
        ],
        "total": 2
      },
      {
        "id": "XS",
        "un": "SO",
        "name": "Somaliland",
        "int_id": 211,
        "db": [
          {
            "id": "XS",
            "name": "Somaliland",
            "int_id": 211
          }
        ],
        "total": 1
      },
      {
        "id": "SS",
        "un": "SS",
        "name": "South Sudan",
        "int_id": 215,
        "db": [
          {
            "id": "SS-B",
            "name": "Bahr el Ghazal",
            "int_id": 1075
          },
          {
            "id": "SS-E",
            "name": "Equatoria",
            "int_id": 1074
          },
          {
            "id": "SS-G",
            "name": "Greater Upper Nile",
            "int_id": 1076
          }
        ],
        "total": 3
      },
      {
        "id": "TZ",
        "un": "TZ",
        "name": "Tanzania",
        "int_id": 226,
        "db": [
          {
            "id": "TZ-C",
            "name": "Central",
            "int_id": 900
          },
          {
            "id": "TZ-NE",
            "name": "Northeast",
            "int_id": 897
          },
          {
            "id": "TZ-NW",
            "name": "Northwest",
            "int_id": 898
          },
          {
            "id": "TZ-P",
            "name": "Pemba",
            "int_id": 903
          },
          {
            "id": "TZ-SH",
            "name": "Southern Highlands",
            "int_id": 899
          },
          {
            "id": "TZ-IO",
            "name": "Tanzanian Coast",
            "int_id": 901
          },
          {
            "id": "TZ-Z",
            "name": "Zanzibar",
            "int_id": 902
          }
        ],
        "total": 7
      },
      {
        "id": "UG",
        "un": "UG",
        "name": "Uganda",
        "int_id": 239,
        "db": [
          {
            "id": "UG-C",
            "name": "Central Region",
            "int_id": 1205
          },
          {
            "id": "UG-E",
            "name": "Eastern Region",
            "int_id": 1204
          },
          {
            "id": "UG-N",
            "name": "Northern Region",
            "int_id": 1203
          },
          {
            "id": "UG-W",
            "name": "Western Region",
            "int_id": 1206
          }
        ],
        "total": 4
      },
      {
        "id": "ZW",
        "un": "ZW",
        "name": "Zimbabwe",
        "int_id": 256,
        "db": [
          {
            "id": "ZW-1",
            "name": "Mashonaland",
            "int_id": 799
          },
          {
            "id": "ZW-2",
            "name": "Matabeleland",
            "int_id": 801
          },
          {
            "id": "ZW-3",
            "name": "Southeast",
            "int_id": 800
          }
        ],
        "total": 3
      }
    ],
    "total": 56
  },
  {
    "id": "AFM",
    "name": "Middle Africa",
    "db": [
      {
        "id": "AO",
        "un": "AO",
        "name": "Angola",
        "int_id": 9,
        "db": [
          {
            "id": "AO-CAB",
            "name": "Cabinda",
            "int_id": 877
          },
          {
            "id": "AO-C",
            "name": "Central Angola",
            "int_id": 881
          },
          {
            "id": "AO-E",
            "name": "Eastern Angola",
            "int_id": 879
          },
          {
            "id": "AO-L",
            "name": "Greater Luanda",
            "int_id": 880
          },
          {
            "id": "AO-N",
            "name": "Northern Angola",
            "int_id": 878
          },
          {
            "id": "AO-S",
            "name": "Southwest Angola",
            "int_id": 876
          }
        ],
        "total": 6
      },
      {
        "id": "CM",
        "un": "CM",
        "name": "Cameroon",
        "int_id": 42,
        "db": [
          {
            "id": "CM-AD",
            "name": "Adamawa",
            "int_id": 1112
          },
          {
            "id": "CM2",
            "name": "Anglophone",
            "int_id": 1115
          },
          {
            "id": "CM3",
            "name": "Coast",
            "int_id": 1114
          },
          {
            "id": "CM1",
            "name": "North",
            "int_id": 1111
          },
          {
            "id": "CM4",
            "name": "South Cameroon Plateau",
            "int_id": 1113
          }
        ],
        "total": 5
      },
      {
        "id": "CF",
        "un": "CF",
        "name": "Central African Republic",
        "int_id": 45,
        "db": [
          {
            "id": "CF-E",
            "name": "East",
            "int_id": 1108
          },
          {
            "id": "CF-N",
            "name": "Northwest",
            "int_id": 1109
          },
          {
            "id": "CF-S",
            "name": "Southwest",
            "int_id": 1110
          }
        ],
        "total": 3
      },
      {
        "id": "TD",
        "un": "TD",
        "name": "Chad",
        "int_id": 46,
        "db": [
          {
            "id": "TD-1",
            "name": "Saharan Chad",
            "int_id": 1105
          },
          {
            "id": "TD-2",
            "name": "Sahelian Chad",
            "int_id": 1106
          },
          {
            "id": "TD-3",
            "name": "Soudanian Chad",
            "int_id": 1107
          }
        ],
        "total": 3
      },
      {
        "id": "CG",
        "un": "CG",
        "name": "Congo-Brazzaville",
        "int_id": 53,
        "db": [
          {
            "id": "CG-CM",
            "name": "Coast and Mayombe",
            "int_id": 1150
          },
          {
            "id": "CG-C",
            "name": "Cuvette",
            "int_id": 1149
          },
          {
            "id": "CG-NV",
            "name": "Niari Valley",
            "int_id": 1148
          },
          {
            "id": "CG-N",
            "name": "Northern Congo",
            "int_id": 1151
          },
          {
            "id": "CG-14",
            "name": "Plateaux",
            "int_id": 1152
          },
          {
            "id": "CG-P",
            "name": "Pool",
            "int_id": 1153
          }
        ],
        "total": 6
      },
      {
        "id": "CD",
        "un": "CD",
        "name": "Congo-Kinshasa",
        "int_id": 54,
        "db": [
          {
            "id": "CD-2",
            "name": "Congo Basin",
            "int_id": 726
          },
          {
            "id": "CD-4",
            "name": "Kasai",
            "int_id": 729
          },
          {
            "id": "CD-5",
            "name": "Katanga",
            "int_id": 727
          },
          {
            "id": "CD-3",
            "name": "Kivu",
            "int_id": 730
          },
          {
            "id": "CD-1",
            "name": "West",
            "int_id": 728
          }
        ],
        "total": 5
      },
      {
        "id": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea",
        "int_id": 70,
        "db": [
          {
            "id": "GQ-AN",
            "name": "Annobón",
            "int_id": 1118
          },
          {
            "id": "GQ-I",
            "name": "Bioko",
            "int_id": 1117
          },
          {
            "id": "GQ-C",
            "name": "Región Continental",
            "int_id": 1116
          }
        ],
        "total": 3
      },
      {
        "id": "GA",
        "un": "GA",
        "name": "Gabon",
        "int_id": 83,
        "db": [
          {
            "id": "GA-H",
            "name": "Central Highlands",
            "int_id": 895
          },
          {
            "id": "GA-C",
            "name": "Coastal Plain",
            "int_id": 896
          },
          {
            "id": "GA-J",
            "name": "Jungle Interior",
            "int_id": 894
          }
        ],
        "total": 3
      },
      {
        "id": "ST",
        "un": "ST",
        "name": "Sao Tome and Principe",
        "int_id": 199,
        "db": [
          {
            "id": "ST-P",
            "name": "Príncipe",
            "int_id": 1239
          },
          {
            "id": "ST-ST",
            "name": "São Tomé",
            "int_id": 1240
          }
        ],
        "total": 2
      }
    ],
    "total": 36
  },
  {
    "id": "AFS",
    "name": "Southern Africa",
    "db": [
      {
        "id": "BW",
        "un": "BW",
        "name": "Botswana",
        "int_id": 32,
        "db": [
          {
            "id": "BW2",
            "name": "Kalahari",
            "int_id": 777
          },
          {
            "id": "BW3",
            "name": "Okavango and Chobe",
            "int_id": 778
          },
          {
            "id": "BW1",
            "name": "Southeast",
            "int_id": 776
          }
        ],
        "total": 3
      },
      {
        "id": "SZ",
        "un": "SZ",
        "name": "Eswatini",
        "int_id": 73
      },
      {
        "id": "LS",
        "un": "LS",
        "name": "Lesotho",
        "int_id": 129
      },
      {
        "id": "NA",
        "un": "NA",
        "name": "Namibia",
        "int_id": 157,
        "db": [
          {
            "id": "NA-CA",
            "name": "Caprivi",
            "int_id": 1077
          },
          {
            "id": "NA-C",
            "name": "Central Namibia",
            "int_id": 1078
          },
          {
            "id": "NA-N",
            "name": "Northern Namibia",
            "int_id": 1080
          },
          {
            "id": "NA-S",
            "name": "Southern Namibia",
            "int_id": 1079
          }
        ],
        "total": 4
      },
      {
        "id": "ZA",
        "un": "ZA",
        "name": "South Africa",
        "int_id": 212,
        "db": [
          {
            "id": "ZA-EC",
            "name": "Eastern Cape",
            "int_id": 578
          },
          {
            "id": "ZA-FS",
            "name": "Free State",
            "int_id": 579
          },
          {
            "id": "ZA-GP",
            "name": "Gauteng",
            "int_id": 580
          },
          {
            "id": "ZA-KZN",
            "name": "KwaZulu-Natal",
            "int_id": 581
          },
          {
            "id": "ZA-LP",
            "name": "Limpopo",
            "int_id": 583
          },
          {
            "id": "ZA-MP",
            "name": "Mpumalanga",
            "int_id": 584
          },
          {
            "id": "ZA-NW",
            "name": "North West",
            "int_id": 582
          },
          {
            "id": "ZA-NC",
            "name": "Northern Cape",
            "int_id": 577
          },
          {
            "id": "ZA-WC",
            "name": "Western Cape",
            "int_id": 576
          }
        ],
        "total": 9
      },
      {
        "id": "ZM",
        "un": "ZM",
        "name": "Zambia",
        "int_id": 255,
        "db": [
          {
            "id": "ZM-CZ",
            "name": "Central Zambia",
            "int_id": 804
          },
          {
            "id": "ZM-08",
            "name": "Copperbelt Province",
            "int_id": 803
          },
          {
            "id": "ZM-03",
            "name": "Eastern Province",
            "int_id": 806
          },
          {
            "id": "ZM-NP",
            "name": "Northern Plateau",
            "int_id": 805
          },
          {
            "id": "ZM-ZB",
            "name": "Zambezi Basin",
            "int_id": 802
          }
        ],
        "total": 5
      }
    ],
    "total": 23
  },
  {
    "id": "ASN",
    "name": "Northern Asia",
    "db": [
      {
        "id": "RU",
        "un": "RU",
        "name": "Russian Federation",
        "int_id": 188,
        "db": [
          {
            "id": "RU-ALT",
            "name": "Altai Krai",
            "int_id": 421
          },
          {
            "id": "RU-AL",
            "name": "Altai Republic",
            "int_id": 422
          },
          {
            "id": "RU-AMU",
            "name": "Amur Oblast",
            "int_id": 427
          },
          {
            "id": "RU-BU",
            "name": "Buryatia",
            "int_id": 425
          },
          {
            "id": "RU-CHE",
            "name": "Chelyabinsk Oblast",
            "int_id": 412
          },
          {
            "id": "RU-CHU",
            "name": "Chukotka Autonomous Okrug",
            "int_id": 432
          },
          {
            "id": "RU-IRK",
            "name": "Irkutsk Oblast",
            "int_id": 424
          },
          {
            "id": "RU-YEV",
            "name": "Jewish Autonomous Oblast",
            "int_id": 428
          },
          {
            "id": "RU-KAM",
            "name": "Kamchatka Krai",
            "int_id": 433
          },
          {
            "id": "RU-KEM",
            "name": "Kemerovo Oblast–Kuzbass",
            "int_id": 420
          },
          {
            "id": "RU-KHA",
            "name": "Khabarovsk Krai",
            "int_id": 429
          },
          {
            "id": "RU-KHM",
            "name": "Khanty-Mansiysk Autonomous Okrug – Ugra",
            "int_id": 419
          },
          {
            "id": "RU-KYA",
            "name": "Krasnoyarsk Krai",
            "int_id": 435
          },
          {
            "id": "RU-KGN",
            "name": "Kurgan Oblast",
            "int_id": 414
          },
          {
            "id": "RU-MAG",
            "name": "Magadan Oblast",
            "int_id": 431
          },
          {
            "id": "RU-NVS",
            "name": "Novosibirsk Oblast",
            "int_id": 417
          },
          {
            "id": "RU-OMS",
            "name": "Omsk Oblast",
            "int_id": 416
          },
          {
            "id": "RU-PRI",
            "name": "Primorsky Krai",
            "int_id": 430
          },
          {
            "id": "RU-KK",
            "name": "Republic of Khakassia",
            "int_id": 436
          },
          {
            "id": "RU-SA",
            "name": "Sakha Republic",
            "int_id": 434
          },
          {
            "id": "RU-SAK",
            "name": "Sakhalin Oblast",
            "int_id": 438
          },
          {
            "id": "RU-SVE",
            "name": "Sverdlovsk Oblast",
            "int_id": 413
          },
          {
            "id": "RU-TOM",
            "name": "Tomsk Oblast",
            "int_id": 418
          },
          {
            "id": "RU-TY",
            "name": "Tuva Republic",
            "int_id": 423
          },
          {
            "id": "RU-TYU",
            "name": "Tyumen Oblast",
            "int_id": 415
          },
          {
            "id": "RU-YAN",
            "name": "Yamalo-Nenets Autonomous Okrug",
            "int_id": 437
          },
          {
            "id": "RU-ZAB",
            "name": "Zabaykalsky Krai",
            "int_id": 426
          }
        ],
        "total": 27
      }
    ],
    "total": 27
  },
  {
    "id": "ASW",
    "name": "Western Asia",
    "db": [
      {
        "id": "XA",
        "un": "GE",
        "name": "Abkhazia",
        "int_id": 1,
        "db": [
          {
            "id": "XA",
            "name": "Abkhazia",
            "int_id": 1
          }
        ],
        "total": 1
      },
      {
        "id": "XD",
        "un": "GB",
        "name": "Akrotiri and Dhekelia (Sovereign Base Areas)",
        "int_id": 3
      },
      {
        "id": "AM",
        "un": "AM",
        "name": "Armenia",
        "int_id": 14
      },
      {
        "id": "AZ",
        "un": "AZ",
        "name": "Azerbaijan",
        "int_id": 18,
        "db": [
          {
            "id": "AZ-1",
            "name": "Azerbaijan",
            "int_id": 1100
          },
          {
            "id": "AZ-K",
            "name": "Karabakh",
            "int_id": 1101
          },
          {
            "id": "AZ-N",
            "name": "Nakhchivan",
            "int_id": 1099
          }
        ],
        "total": 3
      },
      {
        "id": "BH",
        "un": "BH",
        "name": "Bahrain",
        "int_id": 20
      },
      {
        "id": "CY",
        "un": "CY",
        "name": "Cyprus",
        "int_id": 61
      },
      {
        "id": "GE",
        "un": "GE",
        "name": "Georgia",
        "int_id": 85,
        "db": [
          {
            "id": "GE-AJ",
            "name": "Adjara",
            "int_id": 1064
          },
          {
            "id": "GE1",
            "name": "Georgia",
            "int_id": 1065
          }
        ],
        "total": 2
      },
      {
        "id": "IR",
        "un": "IR",
        "name": "Iran",
        "int_id": 108,
        "db": [
          {
            "id": "IR-K",
            "name": "Caspian Region",
            "int_id": 759
          },
          {
            "id": "IR-C",
            "name": "Central Iran",
            "int_id": 756
          },
          {
            "id": "IR-AZ",
            "name": "Iranian Azerbaijan",
            "int_id": 760
          },
          {
            "id": "IR-KUR",
            "name": "Iranian Kurdistan",
            "int_id": 757
          },
          {
            "id": "IR-KH",
            "name": "Khorasan",
            "int_id": 755
          },
          {
            "id": "IR-PG",
            "name": "Persian Gulf Region",
            "int_id": 761
          },
          {
            "id": "IR-11",
            "name": "Sistan and Baluchestan Province",
            "int_id": 762
          },
          {
            "id": "IR-W",
            "name": "Western Iran",
            "int_id": 758
          }
        ],
        "total": 8
      },
      {
        "id": "IQ",
        "un": "IQ",
        "name": "Iraq",
        "int_id": 109,
        "db": [
          {
            "id": "IQ-N",
            "name": "Al-Jazira",
            "int_id": 1128
          },
          {
            "id": "IQ-B",
            "name": "Baghdad Belts",
            "int_id": 1129
          },
          {
            "id": "IQ-D",
            "name": "Iraqi Desert",
            "int_id": 1131
          },
          {
            "id": "IQ-K",
            "name": "Iraqi Kurdistan",
            "int_id": 1127
          },
          {
            "id": "IQ-S",
            "name": "Lower Mesopotamia",
            "int_id": 1130
          }
        ],
        "total": 5
      },
      {
        "id": "IL",
        "un": "IL",
        "name": "Israel",
        "int_id": 112
      },
      {
        "id": "JO",
        "un": "JO",
        "name": "Jordan",
        "int_id": 117
      },
      {
        "id": "KW",
        "un": "KW",
        "name": "Kuwait",
        "int_id": 124
      },
      {
        "id": "LB",
        "un": "LB",
        "name": "Lebanon",
        "int_id": 128
      },
      {
        "id": "XC",
        "un": "CY",
        "name": "Northern Cyprus",
        "int_id": 169
      },
      {
        "id": "OM",
        "un": "OM",
        "name": "Oman",
        "int_id": 172,
        "db": [
          {
            "id": "OM2",
            "name": "Central Oman",
            "int_id": 1215
          },
          {
            "id": "OM-ZU",
            "name": "Dhofar",
            "int_id": 1217
          },
          {
            "id": "OM-MU",
            "name": "Musandam",
            "int_id": 1218
          },
          {
            "id": "OM1",
            "name": "Northern Oman",
            "int_id": 1216
          }
        ],
        "total": 4
      },
      {
        "id": "PS",
        "un": "ZZ",
        "name": "Palestine",
        "int_id": 175
      },
      {
        "id": "QA",
        "un": "QA",
        "name": "Qatar",
        "int_id": 185
      },
      {
        "id": "SA",
        "un": "SA",
        "name": "Saudi Arabia",
        "int_id": 200,
        "db": [
          {
            "id": "SA-S",
            "name": "Asir",
            "int_id": 1183
          },
          {
            "id": "SA-B",
            "name": "Badiah",
            "int_id": 1184
          },
          {
            "id": "SA-04",
            "name": "Eastern Province",
            "int_id": 1182
          },
          {
            "id": "SA-H",
            "name": "Hejaz",
            "int_id": 1186
          },
          {
            "id": "SA-N",
            "name": "Najd",
            "int_id": 1185
          }
        ],
        "total": 5
      },
      {
        "id": "XO",
        "un": "GE",
        "name": "South Ossetia",
        "int_id": 214
      },
      {
        "id": "SY",
        "un": "SY",
        "name": "Syria",
        "int_id": 223
      },
      {
        "id": "TR",
        "un": "TR",
        "name": "Türkiye",
        "int_id": 235,
        "db": [
          {
            "id": "TR-AEG",
            "name": "Aegean",
            "int_id": 701
          },
          {
            "id": "TR-BLC",
            "name": "Black Sea",
            "int_id": 704
          },
          {
            "id": "TR-CAN",
            "name": "Central Anatolia",
            "int_id": 698
          },
          {
            "id": "TR-EAN",
            "name": "Eastern Anatolia",
            "int_id": 700
          },
          {
            "id": "TR-34",
            "name": "Istanbul",
            "int_id": 705
          },
          {
            "id": "TR-MAR",
            "name": "Marmara",
            "int_id": 703
          },
          {
            "id": "TR-MED",
            "name": "Mediterranean",
            "int_id": 699
          },
          {
            "id": "TR-SEA",
            "name": "Southeastern Anatolia",
            "int_id": 702
          }
        ],
        "total": 8
      },
      {
        "id": "AE",
        "un": "AE",
        "name": "United Arab Emirates",
        "int_id": 241,
        "db": [
          {
            "id": "AE-AZ",
            "name": "Abu Dhabi Emirate",
            "int_id": 1196
          },
          {
            "id": "AE-AJ",
            "name": "Ajman Emirate",
            "int_id": 1197
          },
          {
            "id": "AE-DU",
            "name": "Dubai",
            "int_id": 1198
          },
          {
            "id": "AE-FU",
            "name": "Fujairah Emirate",
            "int_id": 1199
          },
          {
            "id": "AE-RK",
            "name": "Ras al-Khaimah",
            "int_id": 1200
          },
          {
            "id": "AE-SH",
            "name": "Sharjah Emirate",
            "int_id": 1201
          },
          {
            "id": "AE-UQ",
            "name": "Umm al-Quwain",
            "int_id": 1202
          }
        ],
        "total": 7
      },
      {
        "id": "YE",
        "un": "YE",
        "name": "Yemen",
        "int_id": 254,
        "db": [
          {
            "id": "YE-N",
            "name": "North Yemen",
            "int_id": 852
          },
          {
            "id": "YE-S",
            "name": "South Yemen",
            "int_id": 853
          }
        ],
        "total": 2
      }
    ],
    "total": 58
  },
  {
    "id": "ASC",
    "name": "Central Asia",
    "db": [
      {
        "id": "KZ",
        "un": "KZ",
        "name": "Kazakhstan",
        "int_id": 118,
        "db": [
          {
            "id": "KZ-AA",
            "name": "Almaty Region",
            "int_id": 744
          },
          {
            "id": "KZ-63",
            "name": "Altai",
            "int_id": 743
          },
          {
            "id": "KZ-K",
            "name": "Caspian Region",
            "int_id": 741
          },
          {
            "id": "KZ-C",
            "name": "Central Kazakhstan",
            "int_id": 742
          },
          {
            "id": "KZ-N",
            "name": "North Kazakhstan",
            "int_id": 746
          },
          {
            "id": "KZ-S",
            "name": "South Kazakhstan",
            "int_id": 745
          }
        ],
        "total": 6
      },
      {
        "id": "KG",
        "un": "KG",
        "name": "Kyrgyzstan",
        "int_id": 125,
        "db": [
          {
            "id": "KG-1",
            "name": "Bishkek and the North",
            "int_id": 721
          },
          {
            "id": "KG-2",
            "name": "Ferghana Valley",
            "int_id": 720
          },
          {
            "id": "KG-Y",
            "name": "Issyk-Kul Region",
            "int_id": 722
          },
          {
            "id": "KG-N",
            "name": "Naryn Region",
            "int_id": 723
          }
        ],
        "total": 4
      },
      {
        "id": "TJ",
        "un": "TJ",
        "name": "Tajikistan",
        "int_id": 225,
        "db": [
          {
            "id": "TJ-GB",
            "name": "Gorno-Badakhshan",
            "int_id": 1160
          },
          {
            "id": "TJ-1",
            "name": "Karategin",
            "int_id": 1161
          },
          {
            "id": "TJ-KT",
            "name": "Khatlon",
            "int_id": 1162
          },
          {
            "id": "TJ-SU",
            "name": "Sughd Region",
            "int_id": 1159
          }
        ],
        "total": 4
      },
      {
        "id": "TM",
        "un": "TM",
        "name": "Turkmenistan",
        "int_id": 236,
        "db": [
          {
            "id": "TM-B",
            "name": "Balkan Region",
            "int_id": 754
          },
          {
            "id": "TM1",
            "name": "North",
            "int_id": 752
          },
          {
            "id": "TM2",
            "name": "South",
            "int_id": 753
          }
        ],
        "total": 3
      },
      {
        "id": "UZ",
        "un": "UZ",
        "name": "Uzbekistan",
        "int_id": 246,
        "db": [
          {
            "id": "UZ-F",
            "name": "Ferghana Valley",
            "int_id": 714
          },
          {
            "id": "UZ-QR",
            "name": "Karakalpakstan",
            "int_id": 715
          },
          {
            "id": "UZ-N",
            "name": "Northern Uzbekistan",
            "int_id": 717
          },
          {
            "id": "UZ-B",
            "name": "Samarkand, Bukhara and Khiva",
            "int_id": 716
          },
          {
            "id": "UZ-S",
            "name": "Southern Uzbekistan",
            "int_id": 718
          },
          {
            "id": "UZ-T",
            "name": "Tashkent Region",
            "int_id": 719
          }
        ],
        "total": 6
      }
    ],
    "total": 23
  },
  {
    "id": "ASS",
    "name": "Southern Asia",
    "db": [
      {
        "id": "AF",
        "un": "AF",
        "name": "Afghanistan",
        "int_id": 2,
        "db": [
          {
            "id": "AF-E",
            "name": "East",
            "int_id": 996
          },
          {
            "id": "AF-NE",
            "name": "Northeast",
            "int_id": 994
          },
          {
            "id": "AF-NW",
            "name": "Northwest",
            "int_id": 997
          },
          {
            "id": "AF-S",
            "name": "South",
            "int_id": 995
          },
          {
            "id": "AF-W",
            "name": "West",
            "int_id": 998
          }
        ],
        "total": 5
      },
      {
        "id": "BD",
        "un": "BD",
        "name": "Bangladesh",
        "int_id": 21,
        "db": [
          {
            "id": "BD-1",
            "name": "Central Bengal Region",
            "int_id": 1230
          },
          {
            "id": "BD-4",
            "name": "Eastern Bengal",
            "int_id": 1227
          },
          {
            "id": "BD-2",
            "name": "Northern Bengal",
            "int_id": 1229
          },
          {
            "id": "BD-3",
            "name": "Southern Bengal",
            "int_id": 1228
          }
        ],
        "total": 4
      },
      {
        "id": "BT",
        "un": "BT",
        "name": "Bhutan",
        "int_id": 28
      },
      {
        "id": "IN",
        "un": "IN",
        "name": "India",
        "int_id": 106,
        "db": [
          {
            "id": "IN-AP",
            "name": "Andhra Pradesh",
            "int_id": 612
          },
          {
            "id": "IN-AR",
            "name": "Arunachal Pradesh",
            "int_id": 615
          },
          {
            "id": "IN-AS",
            "name": "Assam",
            "int_id": 613
          },
          {
            "id": "IN-BR",
            "name": "Bihar",
            "int_id": 605
          },
          {
            "id": "IN-CH",
            "name": "Chandigarh",
            "int_id": 599
          },
          {
            "id": "IN-CT",
            "name": "Chhattisgarh",
            "int_id": 608
          },
          {
            "id": "IN-DL",
            "name": "Delhi",
            "int_id": 595
          },
          {
            "id": "IN-GA",
            "name": "Goa",
            "int_id": 623
          },
          {
            "id": "IN-GJ",
            "name": "Gujarat",
            "int_id": 602
          },
          {
            "id": "IN-HR",
            "name": "Haryana",
            "int_id": 597
          },
          {
            "id": "IN-HP",
            "name": "Himachal Pradesh",
            "int_id": 593
          },
          {
            "id": "IN-JK",
            "name": "Jammu and Kashmir",
            "int_id": 601
          },
          {
            "id": "IN-JH",
            "name": "Jharkhand",
            "int_id": 607
          },
          {
            "id": "IN-KA",
            "name": "Karnataka",
            "int_id": 611
          },
          {
            "id": "IN-KL",
            "name": "Kerala",
            "int_id": 610
          },
          {
            "id": "IN-LA",
            "name": "Ladakh",
            "int_id": 621
          },
          {
            "id": "IN-MP",
            "name": "Madhya Pradesh",
            "int_id": 603
          },
          {
            "id": "IN-MH",
            "name": "Maharashtra",
            "int_id": 604
          },
          {
            "id": "IN-MN",
            "name": "Manipur",
            "int_id": 617
          },
          {
            "id": "IN-ML",
            "name": "Meghalaya",
            "int_id": 616
          },
          {
            "id": "IN-MZ",
            "name": "Mizoram",
            "int_id": 619
          },
          {
            "id": "IN-NL",
            "name": "Nagaland",
            "int_id": 618
          },
          {
            "id": "IN-OR",
            "name": "Odisha",
            "int_id": 609
          },
          {
            "id": "IN-PY",
            "name": "Puducherry",
            "int_id": 592
          },
          {
            "id": "IN-PB",
            "name": "Punjab",
            "int_id": 598
          },
          {
            "id": "IN-RJ",
            "name": "Rajasthan",
            "int_id": 600
          },
          {
            "id": "IN-SK",
            "name": "Sikkim",
            "int_id": 594
          },
          {
            "id": "IN-TN",
            "name": "Tamil Nadu",
            "int_id": 591
          },
          {
            "id": "IN-TG",
            "name": "Telangana",
            "int_id": 620
          },
          {
            "id": "IN-TR",
            "name": "Tripura",
            "int_id": 614
          },
          {
            "id": "IN-UP",
            "name": "Uttar Pradesh",
            "int_id": 596
          },
          {
            "id": "IN-UT",
            "name": "Uttarakhand",
            "int_id": 622
          },
          {
            "id": "IN-WB",
            "name": "West Bengal",
            "int_id": 606
          }
        ],
        "total": 33
      },
      {
        "id": "MV",
        "un": "MV",
        "name": "Maldives",
        "int_id": 139
      },
      {
        "id": "NP",
        "un": "NP",
        "name": "Nepal",
        "int_id": 159
      },
      {
        "id": "PK",
        "un": "PK",
        "name": "Pakistan",
        "int_id": 173,
        "db": [
          {
            "id": "PK-JK",
            "name": "Azad Kashmir",
            "int_id": 845
          },
          {
            "id": "PK-BA",
            "name": "Balochistan",
            "int_id": 840
          },
          {
            "id": "PK-GB",
            "name": "Gilgit-Baltistan",
            "int_id": 843
          },
          {
            "id": "PK-IS",
            "name": "Islamabad Capital Territory",
            "int_id": 844
          },
          {
            "id": "PK-KP",
            "name": "Khyber Pakhtunkhwa",
            "int_id": 846
          },
          {
            "id": "PK-PB",
            "name": "Punjab",
            "int_id": 842
          },
          {
            "id": "PK-SD",
            "name": "Sindh",
            "int_id": 841
          }
        ],
        "total": 7
      },
      {
        "id": "LK",
        "un": "LK",
        "name": "Sri Lanka",
        "int_id": 217,
        "db": [
          {
            "id": "LK-5",
            "name": "Eastern Province",
            "int_id": 1157
          },
          {
            "id": "LK-4",
            "name": "Northern Province",
            "int_id": 1156
          },
          {
            "id": "LK1",
            "name": "West and South",
            "int_id": 1158
          }
        ],
        "total": 3
      }
    ],
    "total": 55
  },
  {
    "id": "ASE",
    "name": "Eastern Asia",
    "db": [
      {
        "id": "CN",
        "un": "CN",
        "name": "China",
        "int_id": 48,
        "db": [
          {
            "id": "CN-AH",
            "name": "Anhui",
            "int_id": 661
          },
          {
            "id": "CN-BJ",
            "name": "Beijing",
            "int_id": 656
          },
          {
            "id": "CN-CQ",
            "name": "Chongqing",
            "int_id": 665
          },
          {
            "id": "CN-FJ",
            "name": "Fujian",
            "int_id": 654
          },
          {
            "id": "CN-GS",
            "name": "Gansu",
            "int_id": 646
          },
          {
            "id": "CN-GD",
            "name": "Guangdong Province",
            "int_id": 655
          },
          {
            "id": "CN-GX",
            "name": "Guangxi",
            "int_id": 650
          },
          {
            "id": "CN-GZ",
            "name": "Guizhou",
            "int_id": 651
          },
          {
            "id": "CN-HI",
            "name": "Hainan Province",
            "int_id": 673
          },
          {
            "id": "CN-HE",
            "name": "Hebei",
            "int_id": 658
          },
          {
            "id": "CN-HL",
            "name": "Heilongjiang",
            "int_id": 649
          },
          {
            "id": "CN-HA",
            "name": "Henan",
            "int_id": 652
          },
          {
            "id": "CN-HB",
            "name": "Hubei",
            "int_id": 671
          },
          {
            "id": "CN-HN",
            "name": "Hunan",
            "int_id": 666
          },
          {
            "id": "CN-NM",
            "name": "Inner Mongolia",
            "int_id": 647
          },
          {
            "id": "CN-JS",
            "name": "Jiangsu",
            "int_id": 662
          },
          {
            "id": "CN-JX",
            "name": "Jiangxi",
            "int_id": 672
          },
          {
            "id": "CN-JL",
            "name": "Jilin",
            "int_id": 648
          },
          {
            "id": "CN-LN",
            "name": "Liaoning",
            "int_id": 657
          },
          {
            "id": "CN-NX",
            "name": "Ningxia",
            "int_id": 669
          },
          {
            "id": "CN-QH",
            "name": "Qinghai",
            "int_id": 643
          },
          {
            "id": "CN-SN",
            "name": "Shaanxi",
            "int_id": 668
          },
          {
            "id": "CN-SD",
            "name": "Shandong",
            "int_id": 660
          },
          {
            "id": "CN-SH",
            "name": "Shanghai",
            "int_id": 663
          },
          {
            "id": "CN-SX",
            "name": "Shanxi",
            "int_id": 670
          },
          {
            "id": "CN-SC",
            "name": "Sichuan",
            "int_id": 664
          },
          {
            "id": "CN-TJ",
            "name": "Tianjin",
            "int_id": 659
          },
          {
            "id": "CN-XZ",
            "name": "Tibet",
            "int_id": 644
          },
          {
            "id": "CN-XJ",
            "name": "Xinjiang",
            "int_id": 645
          },
          {
            "id": "CN-YN",
            "name": "Yunnan",
            "int_id": 667
          },
          {
            "id": "CN-ZJ",
            "name": "Zhejiang",
            "int_id": 653
          }
        ],
        "total": 31
      },
      {
        "id": "HK",
        "un": "CN",
        "name": "Hong Kong",
        "int_id": 103
      },
      {
        "id": "JP",
        "un": "JP",
        "name": "Japan",
        "int_id": 115,
        "db": [
          {
            "id": "JP:D",
            "name": "Chūbu",
            "int_id": 809
          },
          {
            "id": "JP:F",
            "name": "Chūgoku",
            "int_id": 812
          },
          {
            "id": "JP-01",
            "name": "Hokkaido Prefecture",
            "int_id": 815
          },
          {
            "id": "JP:E",
            "name": "Kansai",
            "int_id": 807
          },
          {
            "id": "JP:C",
            "name": "Kantō",
            "int_id": 810
          },
          {
            "id": "JP:H",
            "name": "Kyushu",
            "int_id": 808
          },
          {
            "id": "JP-47",
            "name": "Okinawa",
            "int_id": 814
          },
          {
            "id": "JP:G",
            "name": "Shikoku",
            "int_id": 813
          },
          {
            "id": "JP:B",
            "name": "Tōhoku",
            "int_id": 811
          }
        ],
        "total": 9
      },
      {
        "id": "KP",
        "un": "KP",
        "name": "Korea, North",
        "int_id": 121,
        "db": [
          {
            "id": "KP-3",
            "name": "Hamgyong",
            "int_id": 836
          },
          {
            "id": "KP-4",
            "name": "Hwanghae",
            "int_id": 838
          },
          {
            "id": "KP-2",
            "name": "Kangwon",
            "int_id": 839
          },
          {
            "id": "KP-1",
            "name": "Pyongan",
            "int_id": 837
          }
        ],
        "total": 4
      },
      {
        "id": "KR",
        "un": "KR",
        "name": "Korea, South",
        "int_id": 122,
        "db": [
          {
            "id": "KR-2",
            "name": "Chungcheong",
            "int_id": 1084
          },
          {
            "id": "KR-42",
            "name": "Gangwon",
            "int_id": 1083
          },
          {
            "id": "KR-3",
            "name": "Gyeongsang",
            "int_id": 1082
          },
          {
            "id": "KR-49",
            "name": "Jeju",
            "int_id": 1086
          },
          {
            "id": "KR-4",
            "name": "Jeolla",
            "int_id": 1085
          },
          {
            "id": "KR-1",
            "name": "Seoul Capital Area",
            "int_id": 1081
          }
        ],
        "total": 6
      },
      {
        "id": "MO",
        "un": "CN",
        "name": "Macao",
        "int_id": 135
      },
      {
        "id": "MN",
        "un": "MN",
        "name": "Mongolia",
        "int_id": 151,
        "db": [
          {
            "id": "MN-C",
            "name": "Central Mongolia",
            "int_id": 775
          },
          {
            "id": "MN-E",
            "name": "Eastern Mongolia",
            "int_id": 771
          },
          {
            "id": "MN-G",
            "name": "Gobi",
            "int_id": 772
          },
          {
            "id": "MN-N",
            "name": "Northern Mongolia",
            "int_id": 774
          },
          {
            "id": "MN-W",
            "name": "Western Mongolia",
            "int_id": 773
          }
        ],
        "total": 5
      },
      {
        "id": "TW",
        "un": "CN",
        "name": "Taiwan",
        "int_id": 224
      }
    ],
    "total": 58
  },
  {
    "id": "SEA",
    "name": "Southeast Asia",
    "db": [
      {
        "id": "BN",
        "un": "BN",
        "name": "Brunei Darussalam",
        "int_id": 36,
        "db": [
          {
            "id": "BN",
            "name": "Brunei-Muara, Belait, and Tutong",
            "int_id": 36
          },
          {
            "id": "BN-TE",
            "name": "Temburong",
            "int_id": 1233
          }
        ],
        "total": 2
      },
      {
        "id": "KH",
        "un": "KH",
        "name": "Cambodia",
        "int_id": 41
      },
      {
        "id": "ID",
        "un": "ID",
        "name": "Indonesia",
        "int_id": 107,
        "db": [
          {
            "id": "ID-BA",
            "name": "Bali",
            "int_id": 975
          },
          {
            "id": "ID-BB",
            "name": "Bangka-Belitung Islands",
            "int_id": 984
          },
          {
            "id": "ID-NT",
            "name": "East Nusa Tenggara",
            "int_id": 981
          },
          {
            "id": "ID-JW",
            "name": "Java",
            "int_id": 977
          },
          {
            "id": "ID-KA",
            "name": "Kalimantan (Indonesian Borneo)",
            "int_id": 978
          },
          {
            "id": "ID-MA",
            "name": "Maluku",
            "int_id": 982
          },
          {
            "id": "ID-MU",
            "name": "North Maluku",
            "int_id": 983
          },
          {
            "id": "ID-PP",
            "name": "Papua (Western New Guinea)",
            "int_id": 986
          },
          {
            "id": "ID-KR",
            "name": "Riau Islands",
            "int_id": 985
          },
          {
            "id": "ID-PD",
            "name": "Southwest Papua",
            "int_id": 987
          },
          {
            "id": "ID-SL",
            "name": "Sulawesi",
            "int_id": 979
          },
          {
            "id": "ID-SM",
            "name": "Sumatra",
            "int_id": 980
          },
          {
            "id": "ID-NB",
            "name": "West Nusa Tenggara",
            "int_id": 976
          }
        ],
        "total": 13
      },
      {
        "id": "LA",
        "un": "LA",
        "name": "Laos",
        "int_id": 126,
        "db": [
          {
            "id": "LA:C",
            "name": "Central",
            "int_id": 1250
          },
          {
            "id": "LA:N",
            "name": "North",
            "int_id": 1249
          },
          {
            "id": "LA:S",
            "name": "South",
            "int_id": 1248
          }
        ],
        "total": 3
      },
      {
        "id": "MY",
        "un": "MY",
        "name": "Malaysia",
        "int_id": 138,
        "db": [
          {
            "id": "MY:2",
            "name": "East Coast",
            "int_id": 1126
          },
          {
            "id": "MY-01",
            "name": "Johor",
            "int_id": 1123
          },
          {
            "id": "MY:SA",
            "name": "Sabah",
            "int_id": 1124
          },
          {
            "id": "MY-13",
            "name": "Sarawak",
            "int_id": 1125
          },
          {
            "id": "MY:1",
            "name": "West Coast",
            "int_id": 1122
          }
        ],
        "total": 5
      },
      {
        "id": "MM",
        "un": "MM",
        "name": "Myanmar",
        "int_id": 156,
        "db": [
          {
            "id": "MM-C",
            "name": "Centre",
            "int_id": 1256
          },
          {
            "id": "MM-E",
            "name": "East",
            "int_id": 1254
          },
          {
            "id": "MM-N",
            "name": "North",
            "int_id": 1253
          },
          {
            "id": "MM-S",
            "name": "South",
            "int_id": 1251
          },
          {
            "id": "MM-SE",
            "name": "Southeast",
            "int_id": 1255
          },
          {
            "id": "MM-W",
            "name": "West",
            "int_id": 1252
          }
        ],
        "total": 6
      },
      {
        "id": "PH",
        "un": "PH",
        "name": "Philippines",
        "int_id": 180,
        "db": [
          {
            "id": "PH-ME",
            "name": "Eastern Mindanao",
            "int_id": 642
          },
          {
            "id": "PH-L",
            "name": "Luzon",
            "int_id": 639
          },
          {
            "id": "PH-00",
            "name": "Metro Manila",
            "int_id": 637
          },
          {
            "id": "PH-PLW",
            "name": "Palawan",
            "int_id": 638
          },
          {
            "id": "PH-V",
            "name": "Visayas",
            "int_id": 640
          },
          {
            "id": "PH-MW",
            "name": "Western Mindanao and Sulu",
            "int_id": 641
          }
        ],
        "total": 6
      },
      {
        "id": "SG",
        "un": "SG",
        "name": "Singapore",
        "int_id": 205
      },
      {
        "id": "TH",
        "un": "TH",
        "name": "Thailand",
        "int_id": 227,
        "db": [
          {
            "id": "TH-C",
            "name": "Central",
            "int_id": 585
          },
          {
            "id": "TH-E",
            "name": "Eastern",
            "int_id": 587
          },
          {
            "id": "TH-NE",
            "name": "Isaan",
            "int_id": 586
          },
          {
            "id": "TH-N",
            "name": "Northern",
            "int_id": 588
          },
          {
            "id": "TH-S",
            "name": "Southern",
            "int_id": 589
          },
          {
            "id": "TH-W",
            "name": "Western",
            "int_id": 590
          }
        ],
        "total": 6
      },
      {
        "id": "TL",
        "un": "TL",
        "name": "Timor-Leste",
        "int_id": 228,
        "db": [
          {
            "id": "TL-N",
            "name": "North Coast",
            "int_id": 1194
          },
          {
            "id": "TL-OE",
            "name": "Oecussi",
            "int_id": 1193
          },
          {
            "id": "TL-S",
            "name": "South Coast",
            "int_id": 1195
          }
        ],
        "total": 3
      },
      {
        "id": "VN",
        "un": "VN",
        "name": "Viet Nam",
        "int_id": 249,
        "db": [
          {
            "id": "VN-CHV",
            "name": "Central Highlands",
            "int_id": 1041
          },
          {
            "id": "VN-RDD",
            "name": "Hà Nội",
            "int_id": 1045
          },
          {
            "id": "VN-MRD",
            "name": "Mekong River Delta",
            "int_id": 1040
          },
          {
            "id": "VN-NCC",
            "name": "North Central Coastal Vietnam",
            "int_id": 1043
          },
          {
            "id": "VN-NEV",
            "name": "Northeast Vietnam",
            "int_id": 1039
          },
          {
            "id": "VN-NWV",
            "name": "Northwest Vietnam",
            "int_id": 1046
          },
          {
            "id": "VN-SCC",
            "name": "South Central Coastal Vietnam",
            "int_id": 1042
          },
          {
            "id": "VN-SEV",
            "name": "Southeast Vietnam",
            "int_id": 1044
          }
        ],
        "total": 8
      }
    ],
    "total": 54
  },
  {
    "id": "IND",
    "name": "Indian Ocean",
    "db": [
      {
        "id": "IO",
        "un": "GB",
        "name": "British Indian Ocean Territory",
        "int_id": 35
      },
      {
        "id": "CX",
        "un": "AU",
        "name": "Christmas Island",
        "int_id": 49
      },
      {
        "id": "CC",
        "un": "AU",
        "name": "Cocos (Keeling) Islands",
        "int_id": 50
      },
      {
        "id": "TF",
        "un": "FR",
        "name": "French Southern and Antarctic Lands",
        "int_id": 82,
        "db": [
          {
            "id": "TF",
            "name": "French Southern and Antarctic Lands",
            "int_id": 82
          }
        ],
        "total": 1
      },
      {
        "id": "HM",
        "un": "AU",
        "name": "Heard Island and McDonald Islands",
        "int_id": 100,
        "db": [
          {
            "id": "HM",
            "name": "Heard Island and McDonald Islands",
            "int_id": 100
          }
        ],
        "total": 1
      },
      {
        "id": "IN",
        "un": "IN",
        "name": "India",
        "int_id": 106,
        "db": [
          {
            "id": "IN-AN",
            "name": "Andaman and Nicobar Islands",
            "int_id": 624
          },
          {
            "id": "IN-LD",
            "name": "Lakshadweep",
            "int_id": 625
          }
        ],
        "total": 2
      },
      {
        "id": "MU",
        "un": "MU",
        "name": "Mauritius",
        "int_id": 145,
        "db": [
          {
            "id": "MU:0",
            "name": "Mauritius",
            "int_id": 886
          },
          {
            "id": "MU-RO",
            "name": "Rodrigues",
            "int_id": 887
          }
        ],
        "total": 2
      },
      {
        "id": "YT",
        "un": "FR",
        "name": "Mayotte",
        "int_id": 146
      },
      {
        "id": "RE",
        "un": "FR",
        "name": "Réunion",
        "int_id": 186
      },
      {
        "id": "SC",
        "un": "SC",
        "name": "Seychelles",
        "int_id": 203
      },
      {
        "id": "YE",
        "un": "YE",
        "name": "Yemen",
        "int_id": 254,
        "db": [
          {
            "id": "YE-SU",
            "name": "Socotra",
            "int_id": 854
          }
        ],
        "total": 1
      }
    ],
    "total": 13
  },
  {
    "id": "ANZ",
    "name": "Australia and New Zealand",
    "db": [
      {
        "id": "AU",
        "un": "AU",
        "name": "Australia",
        "int_id": 16,
        "db": [
          {
            "id": "AU-ACT",
            "name": "Australian Capital Territory",
            "int_id": 1093
          },
          {
            "id": "AU-LDH",
            "name": "Lord Howe Island",
            "int_id": 1095
          },
          {
            "id": "AU-NSW",
            "name": "New South Wales",
            "int_id": 1087
          },
          {
            "id": "AU-NT",
            "name": "Northern Territory",
            "int_id": 1088
          },
          {
            "id": "AU-QLD",
            "name": "Queensland",
            "int_id": 1089
          },
          {
            "id": "AU-SA",
            "name": "South Australia",
            "int_id": 1090
          },
          {
            "id": "AU-TAS",
            "name": "Tasmania",
            "int_id": 1094
          },
          {
            "id": "AU-VIC",
            "name": "Victoria",
            "int_id": 1092
          },
          {
            "id": "AU-WA",
            "name": "Western Australia",
            "int_id": 1091
          }
        ],
        "total": 9
      },
      {
        "id": "NZ",
        "un": "NZ",
        "name": "New Zealand",
        "int_id": 162,
        "db": [
          {
            "id": "NZ-CIT",
            "name": "Chatham Islands",
            "int_id": 992
          },
          {
            "id": "NZ:NN",
            "name": "North Island North",
            "int_id": 991
          },
          {
            "id": "NZ:NS",
            "name": "North Island South",
            "int_id": 988
          },
          {
            "id": "NZ:SE",
            "name": "South Island East",
            "int_id": 990
          },
          {
            "id": "NZ:SW",
            "name": "South Island West",
            "int_id": 989
          },
          {
            "id": "NZ-STW",
            "name": "Stewart / Rakiura",
            "int_id": 993
          }
        ],
        "total": 6
      },
      {
        "id": "NF",
        "un": "AU",
        "name": "Norfolk Island",
        "int_id": 167
      }
    ],
    "total": 16
  },
  {
    "id": "MEL",
    "name": "Melanesia",
    "db": [
      {
        "id": "FJ",
        "un": "FJ",
        "name": "Fiji",
        "int_id": 77,
        "db": [
          {
            "id": "FJ-E",
            "name": "Kadavu, Lau, Lomaiviti",
            "int_id": 1242
          },
          {
            "id": "FJ-R",
            "name": "Rotuma",
            "int_id": 1244
          },
          {
            "id": "FJ-N",
            "name": "Vanua Levu",
            "int_id": 1243
          },
          {
            "id": "FJ-VL",
            "name": "Viti Levu",
            "int_id": 1241
          }
        ],
        "total": 4
      },
      {
        "id": "NC",
        "un": "FR",
        "name": "New Caledonia",
        "int_id": 161,
        "db": [
          {
            "id": "NC:LIP",
            "name": "Loyalty Islands Province",
            "int_id": 849
          },
          {
            "id": "NC:NP",
            "name": "North Province",
            "int_id": 850
          },
          {
            "id": "NC:SP",
            "name": "South Province",
            "int_id": 851
          }
        ],
        "total": 3
      },
      {
        "id": "PG",
        "un": "PG",
        "name": "Papua New Guinea",
        "int_id": 177,
        "db": [
          {
            "id": "PG-NSB",
            "name": "Bougainville",
            "int_id": 768
          },
          {
            "id": "PG-C",
            "name": "Central",
            "int_id": 763
          },
          {
            "id": "PG-H",
            "name": "Highlands",
            "int_id": 764
          },
          {
            "id": "PG-MBA",
            "name": "Milne Bay",
            "int_id": 767
          },
          {
            "id": "PG-M",
            "name": "Momase",
            "int_id": 766
          },
          {
            "id": "PG-NB",
            "name": "New Britain",
            "int_id": 769
          },
          {
            "id": "PG-IM",
            "name": "New Ireland and Manus",
            "int_id": 770
          },
          {
            "id": "PG-S",
            "name": "South",
            "int_id": 765
          }
        ],
        "total": 8
      },
      {
        "id": "SB",
        "un": "SB",
        "name": "Solomon Islands",
        "int_id": 209
      },
      {
        "id": "VU",
        "un": "VU",
        "name": "Vanuatu",
        "int_id": 247
      }
    ],
    "total": 17
  },
  {
    "id": "MIC",
    "name": "Micronesia",
    "db": [
      {
        "id": "GU",
        "un": "US",
        "name": "Guam",
        "int_id": 93,
        "db": [
          {
            "id": "GU",
            "name": "Guam",
            "int_id": 93
          }
        ],
        "total": 1
      },
      {
        "id": "JP",
        "un": "JP",
        "name": "Japan",
        "int_id": 115,
        "db": [
          {
            "id": "JP-13:1",
            "name": "Ogasawara (Bonin) Islands",
            "int_id": 816
          }
        ],
        "total": 1
      },
      {
        "id": "KI",
        "un": "KI",
        "name": "Kiribati",
        "int_id": 120,
        "db": [
          {
            "id": "KI-G",
            "name": "Gilbert Islands",
            "int_id": 1264
          },
          {
            "id": "KI-L",
            "name": "Line Islands",
            "int_id": 1263
          },
          {
            "id": "KI-P",
            "name": "Phoenix Islands",
            "int_id": 1262
          }
        ],
        "total": 3
      },
      {
        "id": "MH",
        "un": "MH",
        "name": "Marshall Islands",
        "int_id": 142
      },
      {
        "id": "FM",
        "un": "FM",
        "name": "Micronesia",
        "int_id": 148,
        "db": [
          {
            "id": "FM-TRK",
            "name": "Chuuk",
            "int_id": 1224
          },
          {
            "id": "FM-KSA",
            "name": "Kosrae",
            "int_id": 1225
          },
          {
            "id": "FM-PNI",
            "name": "Pohnpei",
            "int_id": 1226
          },
          {
            "id": "FM-YAP",
            "name": "Yap",
            "int_id": 1223
          }
        ],
        "total": 4
      },
      {
        "id": "NR",
        "un": "NR",
        "name": "Nauru",
        "int_id": 158
      },
      {
        "id": "MP",
        "un": "US",
        "name": "Northern Mariana Islands",
        "int_id": 170,
        "db": [
          {
            "id": "MP",
            "name": "Northern Mariana Islands",
            "int_id": 170
          }
        ],
        "total": 1
      },
      {
        "id": "PW",
        "un": "PW",
        "name": "Palau",
        "int_id": 174
      }
    ],
    "total": 13
  },
  {
    "id": "POL",
    "name": "Polynesia",
    "db": [
      {
        "id": "AS",
        "un": "US",
        "name": "American Samoa",
        "int_id": 7,
        "db": [
          {
            "id": "AS",
            "name": "American Samoa",
            "int_id": 7
          }
        ],
        "total": 1
      },
      {
        "id": "CL",
        "un": "CL",
        "name": "Chile",
        "int_id": 47,
        "db": [
          {
            "id": "CL-VS:1",
            "name": "Easter Island",
            "int_id": 736
          }
        ],
        "total": 1
      },
      {
        "id": "CK",
        "un": "NZ",
        "name": "Cook Islands",
        "int_id": 55
      },
      {
        "id": "PF",
        "un": "FR",
        "name": "French Polynesia",
        "int_id": 81,
        "db": [
          {
            "id": "PF-A",
            "name": "Austral Islands",
            "int_id": 1260
          },
          {
            "id": "PF-G",
            "name": "Gambiers",
            "int_id": 1258
          },
          {
            "id": "PF-M",
            "name": "Marquesas",
            "int_id": 1257
          },
          {
            "id": "PF-S",
            "name": "Society Islands",
            "int_id": 1261
          },
          {
            "id": "PF-T",
            "name": "Tuamotus",
            "int_id": 1259
          }
        ],
        "total": 5
      },
      {
        "id": "NU",
        "un": "NZ",
        "name": "Niue",
        "int_id": 166
      },
      {
        "id": "PN",
        "un": "GB",
        "name": "Pitcairn",
        "int_id": 181
      },
      {
        "id": "WS",
        "un": "WS",
        "name": "Samoa",
        "int_id": 197,
        "db": [
          {
            "id": "WS-S",
            "name": "Savaiʻi",
            "int_id": 1272
          },
          {
            "id": "WS-U",
            "name": "Upolu",
            "int_id": 1273
          }
        ],
        "total": 2
      },
      {
        "id": "TK",
        "un": "NZ",
        "name": "Tokelau",
        "int_id": 230
      },
      {
        "id": "TO",
        "un": "TO",
        "name": "Tonga",
        "int_id": 231,
        "db": [
          {
            "id": "TO-02",
            "name": "Haʻapai",
            "int_id": 1207
          },
          {
            "id": "TO1",
            "name": "Tongatapu group",
            "int_id": 1209
          },
          {
            "id": "TO3",
            "name": "Vavaʻu and Niua",
            "int_id": 1208
          }
        ],
        "total": 3
      },
      {
        "id": "TV",
        "un": "TV",
        "name": "Tuvalu",
        "int_id": 238
      },
      {
        "id": "UM",
        "un": "US",
        "name": "United States Minor Outlying Islands",
        "int_id": 243
      },
      {
        "id": "US",
        "un": "US",
        "name": "United States of America",
        "int_id": 244,
        "db": [
          {
            "id": "US-HI",
            "name": "Hawaii",
            "int_id": 538
          }
        ],
        "total": 1
      },
      {
        "id": "WF",
        "un": "FR",
        "name": "Wallis and Futuna",
        "int_id": 252,
        "db": [
          {
            "id": "WF-F",
            "name": "Futuna",
            "int_id": 1270
          },
          {
            "id": "WF-W",
            "name": "Wallis",
            "int_id": 1271
          }
        ],
        "total": 2
      }
    ],
    "total": 21
  },
  {
    "id": "ANT",
    "name": "Antarctica",
    "db": [
      {
        "id": "AQ",
        "un": "ZZ",
        "name": "Antarctica",
        "int_id": 11
      }
    ],
    "total": 1
  }
];
